// import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";
// import React, { useEffect, useState, createContext, useContext } from 'react';
// import HomePage from "./Components/MainPage/HomePage";
// import SignIn from "./Components/MainPage/SignIn";
// import SignUp from "./Components/MainPage/SignUp"
// import Course from "./Components/MainPage/Course";
// import AboutOne from "./Components/MainPage/AboutOne"
// import EmailConfirm from "./Components/MainPage/EmailConfirm";
// import ContactUs from "./Components/MainPage/ContactUs"
// import Downloads from "./Components/MainPage/Downloads"
// import ErrorPage from "./Components/404ErrorPage";
// import MentorActivities from "./Components/MainPage/MentorActivities";
// import Authentication from "./Components/Authentication/Authentication";
// import AddBatch from "./Components/MainPage/AddBatch";
// import AddStudent from "./Components/MainPage/AddStudent"
// import Blog from "./Components/MainPage/Blog"
// import AddBlog from "./Components/MainPage/AddBlog";
// import EditBatch from "./Components/MainPage/EditBatch";
// import EditProfile from "./Components/MainPage/EditProfile";
// import UserManagement from "./Components/MainPage/UserManagement";
// import CreateNewUser from "./Components/MainPage/CreateNewUser";
// import CourseManagement from "./Components/MainPage/CourseManagement";
// import CreateNewCourse from "./Components/MainPage/CreateNewCourse";
// import ActivityManagement from "./Components/MainPage/ActivityManagement";
// import CourseDownloadsManagement from "./Components/MainPage/CourseDownloadsManagement";
// import SubActivityManagement from "./Components/MainPage/SubActivityManagement";
// import AdvancedCourse from "./Components/MainPage/AdvancedCourse";
// import CourseMappingManagement from "./Components/MainPage/CourseMappingManagement";
// import OneCompilerIframe from "./Components/MainPage/OneCompilerIframe";
// import Admiration from "./Components/MainPage/Admiration";
// import Popup from "./Components/MainPage/Popup";
// import NotificationService from "./Components/MainPage/NotificationService";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { AuthenticateUser, FetchHomePageDetails } from './api/aws-api';
// import { ConstructorEventPost, ConstructorEventGet } from './Event/event';
// import ActivityOne from "./Components/MainPage/ActivityOne";
// import ActivityOneOne from "./Components/MainPage/ActivityOneOne";
// import ActivityTwo from "./Components/MainPage/ActivityTwo";
// import ActivityTwoOne from "./Components/MainPage/ActivityTwoOne";
// import ActivityThree from "./Components/MainPage/ActivityThree";
// import ActivityFour from "./Components/MainPage/ActivityFour";
// import ActivityNine from "./Components/MainPage/ActivityNine";
// import StoryTellerActivity from "./Components/MainPage/StoryTellerActivity";
// import StoryTellerActivityOne from "./Components/MainPage/StoryTellerActivityOne";
// import ActivitySeven from "./Components/MainPage/ActivitySeven"
// import ActivityEight from "./Components/MainPage/ActivityEight"
// import ActivityFive from "./Components/MainPage/ActivityFive"
// import ActivitySix from "./Components/MainPage/ActivitySix"
// import ActivityTen from "./Components/MainPage/ActivityTen"
// import ActivityEleven from "./Components/MainPage/ActivityEleven"
// import AppLabSessionone from "./Components/MainPage/AppLabSessionone"
// import AppLabSessionthree from "./Components/MainPage/AppLabSessionthree"
// import Webusb from "./Components/MainPage/Webusb"
// import AppLabSessionfour from "./Components/MainPage/AppLabSessionfour"
// import AppLabSessionfive from "./Components/MainPage/AppLabSessionfive"
// import AppLabSessionsix from "./Components/MainPage/AppLabSessionsix"
// import AppLabSessionseven from "./Components/MainPage/AppLabSessionseven"
// import AppLabSessioneight from "./Components/MainPage/AppLabSessioneight"
// import AppLabSessionnine from "./Components/MainPage/AppLabSessionnine"
// import AppLabSessionten from "./Components/MainPage/AppLabSessionten"
// import AssiginingCourseToMentor from "./Components/MainPage/AssiginingCourseToMentor"
// import AppLabSessioneleven from "./Components/MainPage/AppLabSessioneleven"
// import VideoCallActivity from "./Components/MainPage/VideoCallActivity";
// import VoiceCallActivity from "./Components/MainPage/VoiceCallActivity";
// import ChatScreen from "./Components/MainPage/ChatScreen";
// import GoogleMeet from "./Components/MainPage/GoogleMeet";
// import BatchManagement from "./Components/MainPage/BatchManagement";
// import AssignBatchToTheMentor from "./Components/MainPage/AssignBatchToMentor";
// import AccountsManagement from "./Components/MainPage/AccountsManagement";
// import CreateNewBatch from "./Components/MainPage/CreateNewBatch";

// // ------------------------------------------------------------------------------------------

// import Index1 from "./Components/MainPage/mentalmath/Index1";
// import Index2 from "./Components/MainPage/mentalmath/Index2";
// import Placevalue from "./Components/MainPage/mentalmath/Placevalue";
// import Placevalue2 from "./Components/MainPage/mentalmath/Placevalue2";
// import Placevalue3 from "./Components/MainPage/mentalmath/Placevalue3";
// import Placevalue4 from "./Components/MainPage/mentalmath/Placevalue4";
// import Divisible2 from "./Components/MainPage/mentalmath/Divisible2"
// import Multiple1 from "./Components/MainPage/mentalmath/Multiple"
// import Multiple2 from "./Components/MainPage/mentalmath/Multiple2"
// import Multiple3 from "./Components/MainPage/mentalmath/multiple3"
// import Newactivityone from "./Components/MainPage/mentalmath/Newactivityone"
// import Newactivitytwo from "./Components/MainPage/mentalmath/Newactivitytwo"
// import Newactivitythree from "./Components/MainPage/mentalmath/Newactivitythree"


// import Halving from "./Components/MainPage/mentalmath/Halving"
// import Backtrack1 from "./Components/MainPage/mentalmath/Backtrack1";
// import Backtrack2 from "./Components/MainPage/mentalmath/Backtrack2";
// import Backtrack3 from "./Components/MainPage/mentalmath/Backtrack3";
// import Compositesmash from "./Components/MainPage/mentalmath/Compositesmash";
// import Prime from "./Components/MainPage/mentalmath/Prime";
// import Angles2 from "./Components/MainPage/mentalmath/Angles2";
// import Shapetrain from "./Components/MainPage/mentalmath/Shapetrain";
// import Shapes from "./Components/MainPage/mentalmath/Shapes";
// import Task2 from "./Components/MainPage/mentalmath/Task2";
// import Task3 from "./Components/MainPage/mentalmath/Task3";



// import Estimation2 from "./Components/MainPage/mentalmath/Estimation2";
// import Estimation1 from "./Components/MainPage/mentalmath/Estimation1";
// import Estimation3 from "./Components/MainPage/mentalmath/Estimation3";
// import Complement1 from "./Components/MainPage/mentalmath/Complement1";
// import Complement2 from "./Components/MainPage/mentalmath/Complement2";
// import Count from "./Components/MainPage/mentalmath/Count";
// import Dh from "./Components/MainPage/mentalmath/Dh";

// import Divisible3 from "./Components/MainPage/mentalmath/Divisible3";
// import Divisible from "./Components/MainPage/mentalmath/Divisible";
// import Indexl2 from "./Components/MainPage/mentalmath/Indexl2";
// import Indexl1 from "./Components/MainPage/mentalmath/Indexl1";
// import Lr1 from "./Components/MainPage/mentalmath/Lr1";
// import Lr2 from "./Components/MainPage/mentalmath/Lr2";
// import Lr3 from "./Components/MainPage/mentalmath/Lr3";
// import Rounding1 from "./Components/MainPage/mentalmath/Rounding1";
// import Rounding2 from "./Components/MainPage/mentalmath/Rounding2";

// import Factors from "./Components/MainPage/mentalmath/Factors";
// import Factors2 from "./Components/MainPage/mentalmath/Factors2";
// import Grouping1 from "./Components/MainPage/mentalmath/Grouping1";
// import Session141 from './Components/MainPage/mentalmath/lthree/Session141';
// import Session142 from './Components/MainPage/mentalmath/lthree/Session142';
// import Session15 from './Components/MainPage/mentalmath/lthree/Session15';
// import Session152 from './Components/MainPage/mentalmath/lthree/Session152';
// import Factors21 from './Components/MainPage/mentalmath/lthree/Factors21'

// import Session16 from './Components/MainPage/mentalmath/lthree/Session16'
// import Session162 from './Components/MainPage/mentalmath/lthree/Session162'
// import Session172 from './Components/MainPage/mentalmath/lthree/Session172'
// import Session171 from './Components/MainPage/mentalmath/lthree/Session171';
// import Halfof from "./Components/MainPage/mentalmath/level2/Halfsofhtml"
// import Session9 from "./Components/MainPage/mentalmath/level2/Session9"
// import Session9part2 from "./Components/MainPage/mentalmath/level2/Session9part2"
// import Session10 from "./Components/MainPage/mentalmath/level2/Sesssion10"
// import Session11 from "./Components/MainPage/mentalmath/level2/Session11"
// import Session11part2 from "./Components/MainPage/mentalmath/level2/Session11part2"
// import Session11part3 from "./Components/MainPage/mentalmath/level2/Session11part3"
// import Session11part4 from "./Components/MainPage/mentalmath/level2/Session11part4"
// import Session7 from "./Components/MainPage/mentalmath/level2/Sessions7"
// import Session8 from "./Components/MainPage/mentalmath/level2/Sessions8v2"
// import Integer2 from "./Components/MainPage/mentalmath/level2/Interger2"
// import Subtract1000 from "./Components/MainPage/mentalmath/level2/Subtract1000"
// import Subtract10000 from "./Components/MainPage/mentalmath/level2/Subtract10000"
// import Oneandhalf from "./Components/MainPage/mentalmath/level2/Oneandhalf"
// import Level1quiz from "./Components/MainPage/mentalmath/level2/Level1quiz"
// import Level2quiz from "./Components/MainPage/mentalmath/level2/Level2quiz"
// import Level3quiz from "./Components/MainPage/mentalmath/level2/Level3quiz"
// import Level4quiz from "./Components/MainPage/mentalmath/level2/Level4quiz"
// import Level5quiz from "./Components/MainPage/mentalmath/level2/Level5quiz"
// import Multiplynew from "./Components/MainPage/mentalmath/level2/Newactivitymultiply"
// import Twodigit from "./Components/MainPage/mentalmath/level2/Twodigit"
// import Twodigitb from "./Components/MainPage/mentalmath/level2/Twodigitb"



// import Sessions20v4 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
// import Sessions19v1 from "./Components/MainPage/mentalmath/level4/Sessions19v1"
// import Sessions19v2 from "./Components/MainPage/mentalmath/level4/Sessions19v2"
// import Sessions19v3 from "./Components/MainPage/mentalmath/level4/Sessions19v3"
// import Sessions20v1 from "./Components/MainPage/mentalmath/level4/Sessions20v1"
// import Sessions20v2 from "./Components/MainPage/mentalmath/level4/Sessions20v2"
// import Sessions20v3 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
// import Sessions20v5 from "./Components/MainPage/mentalmath/level4/Sessions20v5"
// import Sessions21v1 from "./Components/MainPage/mentalmath/level4/Sessions21v1"
// import Sessions21v2 from "./Components/MainPage/mentalmath/level4/Sessions21v2"
// import Magicsquare from "./Components/MainPage/mentalmath/level4/Magicsquare"
// import Proportion from "./Components/MainPage/mentalmath/level4/Proportion"
// import Scaling from "./Components/MainPage/mentalmath/level4/Scaling"
// import Ratio from "./Components/MainPage/mentalmath/level4/Ratio"
// import Gessop from "./Components/MainPage/mentalmath/level4/Gessop"
// import Nameriddle from './Components/MainPage/mentalmath/level4/Nameriddle'
// import TC1 from "./Components/MainPage/mentalmath/level4/Tc1"
// import TC2 from "./Components/MainPage/mentalmath/level4/Tc2"
// import TC3 from "./Components/MainPage/mentalmath/level4/Tc3"
// import Start from "./Components/MainPage/mentalmath/level4/start1"


// import Activity1 from "./Components/MainPage/mentalmath/lfive/Activity1";
// import Activity2 from "./Components/MainPage/mentalmath/lfive/Activity2";
// import Angle from "./Components/MainPage/mentalmath/lfive/Angle";
// import Measurement from "./Components/MainPage/mentalmath/lfive/Measurement";
// import Level1 from "./Components/MainPage/mentalmath/lfive/Level1";
// import Level2 from "./Components/MainPage/mentalmath/lfive/Level2";
// import Level3 from "./Components/MainPage/mentalmath/lfive/Level3";
// import Level4 from "./Components/MainPage/mentalmath/lfive/Level4";
// import Level5 from "./Components/MainPage/mentalmath/lfive/Level5";
// import Time from "./Components/MainPage/mentalmath/lfive/Time";
// import Divisoncarnival from "./Components/MainPage/mentalmath/lfive/Divisoncarnival";
// import Divisoncarnival2 from "./Components/MainPage/mentalmath/lfive/Divisoncarnival2";
// import Meterandcm from "./Components/MainPage/mentalmath/lfive/Meterandcm";
// import Percentnew from "./Components/MainPage/mentalmath/lfive/percentnew";
// import Weight from "./Components/MainPage/mentalmath/lfive/Weight";

// import Bargraph2 from "./Components/MainPage/mentalmath/level6/Bargraph2"
// import Bargraph from "./Components/MainPage/mentalmath/level6/Bargraph"
// import Datainterpretation from "./Components/MainPage/mentalmath/level6/Datainterpretation"
// import MatchPieChart from "./Components/MainPage/mentalmath/level6/Matchpiechart";
// import Mean from "./Components/MainPage/mentalmath/level6/Mean"
// import Median from "./Components/MainPage/mentalmath/level6/Median"
// import Mode from "./Components/MainPage/mentalmath/level6/Mode"
// import Piechart from "./Components/MainPage/mentalmath/level6/Piechart"
// import Puzzlepiechart from "./Components/MainPage/mentalmath/level6/Puzzlepiechart"
// import Survey from "./Components/MainPage/mentalmath/level6/Survey"
// import L7aone from "./Components/MainPage/mentalmath/level7/Activityone"
// import L7atwo from "./Components/MainPage/mentalmath/level7/Activitytwo"
// import L7athree from "./Components/MainPage/mentalmath/level7/Activitythree"
// import L7afour from "./Components/MainPage/mentalmath/level7/Activity4"
// import L7afive from "./Components/MainPage/mentalmath/level7/Activity5"
// import L7asix from "./Components/MainPage/mentalmath/level7/Activity6"




// import Activity11 from "./Components/MainPage/IntermediateAi/Activity1"
// import Activity12 from "./Components/MainPage/IntermediateAi/Activity2"
// import Activity13 from "./Components/MainPage/IntermediateAi/Activity3"
// import Activity14 from "./Components/MainPage/IntermediateAi/Activity4"
// import Activity15 from "./Components/MainPage/IntermediateAi/Activity5"
// import Activity16 from "./Components/MainPage/IntermediateAi/Activity6"
// import Activity17 from "./Components/MainPage/IntermediateAi/Activity7"
// import Activity18 from "./Components/MainPage/IntermediateAi/Activity8"
// import Activity19 from "./Components/MainPage/IntermediateAi/Activity9"
// import Activity20 from "./Components/MainPage/IntermediateAi/Activity10"
// import Activity21 from "./Components/MainPage/IntermediateAi/Activity11"
// import Activity22 from "./Components/MainPage/IntermediateAi/Activity12"
// import Activity23 from "./Components/MainPage/IntermediateAi/Activity13"
// import Activity24 from "./Components/MainPage/IntermediateAi/Activity14"

// import Digital1 from "./Components/MainPage/Digitalbasics/Digital1"
// import Digital2 from "./Components/MainPage/Digitalbasics/Digital2"
// import Digital3 from "./Components/MainPage/Digitalbasics/Digital3"
// import Digital4 from "./Components/MainPage/Digitalbasics/Digital4"
// import Digital5 from "./Components/MainPage/Digitalbasics/Digital5"
// import Digital6 from "./Components/MainPage/Digitalbasics/Digital6"
// import Digital7 from "./Components/MainPage/Digitalbasics/Digital7"
// import Digital9 from "./Components/MainPage/Digitalbasics/Digital9"
// import Digital10 from "./Components/MainPage/Digitalbasics/Digital10"
// import Digital11 from "./Components/MainPage/Digitalbasics/Digital11"
// import Digital12 from "./Components/MainPage/Digitalbasics/Digital12"

// import Count2s from "./Components/MainPage/mentalmath/Count2s"
// import Count10s from "./Components/MainPage/mentalmath/Count10s"
// import Count100s from "./Components/MainPage/mentalmath/Count100s"
// import Dashboard from "./Components/MainPage/Dashboard";

// import Break from "./Components/MainPage/Gcs/Break";
// import Flowchart from "./Components/MainPage/Gcs/Flowchart";
// import TraceTable from "./Components/MainPage/Gcs/TraceTable";
// import Binarytodecimal from "./Components/MainPage/Gcs/Binarytodecimal";
// import Decimaltobinary from "./Components/MainPage/Gcs/Decimaltobinary";
// import Hexadecimal from "./Components/MainPage/Gcs/Hexadecimal";
// import Unicode from "./Components/MainPage/Gcs/Unicode";
// import Pixelart from "./Components/MainPage/Gcs/Pixelart";
// import Ascii from "./Components/MainPage/Gcs/Ascii";
// import Sound from "./Components/MainPage/Gcs/Sound";



// export const AuthenticationState = createContext();

// function App() {
  
//   const [userAuthenticated, setuserAuthenticated] = useState(false)
//   const [verifiedAsMentor, setVerifiedAsMentor] = useState(false)
//   const [verifiedAsAdmin, setVerifiedAsAdmin] = useState(false)
//   const [verifiedAsBDE, setVerifiedAsBDE] = useState(false)
//   const location = useLocation();
//   const navigate = useNavigate()

//   useEffect(() => {
//     if (location.pathname !== "/signUp") {
//       const lastLoginTime = localStorage.getItem('lastLoginTime')
//       const authToken = localStorage.getItem('authToken')
//       console.log(location.pathname)
//       console.log("triggered")
//       if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && !userAuthenticated) {
//         CheckStatus(authToken)
//         console.log("app triggered")
//       }
//       else if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && userAuthenticated) { }
//       else if (authToken && (Date.now() - lastLoginTime) > 24 * 60 * 120 * 1000 && userAuthenticated) {
//         setuserAuthenticated(false)
//         navigate("/signIn")
//         console.log("user time out")
//       }
//       else {
//         setuserAuthenticated(false)
//       }
//     }
//   }, [location.pathname,  userAuthenticated]
//   );


 

// // useEffect(() => {
// //   // If user is on root path or /home, redirect to signIn
// //   if (location.pathname === "/" || location.pathname === "/home") {
// //     navigate("/signIn");
// //     return;
// //   }


// useEffect(() => {
//     // If the URL is exactly "/home" or just "/", redirect to signIn
//     if (location.pathname === "/home" || location.pathname === "/") {
//       navigate("/signIn", { replace: true });
//     }
//   }, [location.pathname]);



// //   // Only try auto-login for protected routes
// //   if (location.pathname.startsWith("/codomo/")) {
// //     const lastLoginTime = localStorage.getItem('lastLoginTime');
// //     const authToken = localStorage.getItem('authToken');
// //     const userKey = localStorage.getItem('UserKey');
    
// //     if (authToken && lastLoginTime && userKey && 
// //         userKey !== "undefined" && userKey !== "null") {
// //       const timeDiff = Date.now() - parseInt(lastLoginTime);
// //       if (timeDiff < 24 * 60 * 120 * 1000 && !userAuthenticated) {
// //         CheckStatus(authToken);
// //       } else if (timeDiff >= 24 * 60 * 120 * 1000) {
// //         localStorage.removeItem('authToken');
// //         localStorage.removeItem('lastLoginTime');
// //         localStorage.removeItem('UserKey');
// //         setuserAuthenticated(false);
// //         navigate("/signIn");
// //       }
// //     }
// //   }
// // }, [location.pathname, userAuthenticated]); // ← Keep this dependency



//   // const CheckStatus = async (authToken) => {
//   //   const storedData = localStorage.getItem('UserKey');
//   //   if (storedData !== "undefined" && storedData !== "null" && storedData !== undefined && storedData !== null) {
//   //     const params = JSON.parse(storedData)
//   //     fetchdata(JSON.parse(storedData))
//   //     params["authToken"] = authToken
//   //     const responsedata = await ConstructorEventPost(AuthenticateUser, params)
//   //     if (responsedata === "authentication_success") { setuserAuthenticated(true) }
//   //     else if (responsedata === "authentication_failed") { setuserAuthenticated(false); navigate("/signIn") }
//   //     else { setuserAuthenticated(false); navigate("/signIn") }
//   //   }
//   //   else { setuserAuthenticated(false); navigate("/signIn") }
//   // }

//   // const CheckStatus = async (authToken) => {
//   //   const storedData = localStorage.getItem('UserKey');
//   //   if (storedData !== "undefined" && storedData !== "null" && storedData !== undefined && storedData !== null) {
//   //     const params = JSON.parse(storedData)
//   //     fetchdata(JSON.parse(storedData))
//   //     params["authToken"] = authToken
//   //     try {
//   //       const timeoutPromise = new Promise((_, reject) =>
//   //         setTimeout(() => reject(new Error('timeout')), 10000)
//   //       );
//   //       const responsedata = await Promise.race([
//   //         ConstructorEventPost(AuthenticateUser, params),
//   //         timeoutPromise
//   //       ])
//   //       if (responsedata === "authentication_success") { setuserAuthenticated(true) }
//   //       else if (responsedata === "authentication_failed") { setuserAuthenticated(false); navigate("/signIn") }
//   //       else { setuserAuthenticated(false); navigate("/signIn") }
//   //     } catch (e) {
//   //       console.warn("CheckStatus failed or timed out:", e)
//   //       setuserAuthenticated(false)
//   //       navigate("/signIn")
//   //     }
//   //   }
//   //   else { setuserAuthenticated(false); navigate("/signIn") }
//   // }



//   const CheckStatus = async (authToken) => {
//   const storedData = localStorage.getItem('UserKey');
  
//   if (!storedData || storedData === "undefined" || storedData === "null") {
//     setuserAuthenticated(false);
//     navigate("/signIn");
//     return;
//   }

//   try {
//     const params = JSON.parse(storedData);
//     fetchdata(params);
//     params["authToken"] = authToken;
    
//     const timeoutPromise = new Promise((_, reject) =>
//       setTimeout(() => reject(new Error('timeout')), 10000)
//     );
    
//     const responsedata = await Promise.race([
//       ConstructorEventPost(AuthenticateUser, params),
//       timeoutPromise
//     ]);
    
//     if (responsedata === "authentication_success") {
//       setuserAuthenticated(true);
//       // Only navigate if we're not already on home
//       if (location.pathname !== "/codomo/home") {
//         navigate("/codomo/home");
//       }
//     } else {
//       // Authentication failed - clear session and go to signIn
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('lastLoginTime');
//       localStorage.removeItem('UserKey');
//       setuserAuthenticated(false);
//       navigate("/signIn");
//     }
//   } catch (e) {
//     console.warn("CheckStatus failed:", e);
//     // On error, clear session to prevent infinite loop
//     localStorage.removeItem('authToken');
//     localStorage.removeItem('lastLoginTime');
//     localStorage.removeItem('UserKey');
//     setuserAuthenticated(false);
//     navigate("/signIn");
//   }
// };



//   const fetchdata = async (params) => {
//     const responsedata = await ConstructorEventGet(FetchHomePageDetails, params)
//     sessionStorage.setItem('UserData', JSON.stringify(responsedata[0]))
//     checkUserType(responsedata[0])
//   }

//   function checkUserType(data) {
//     const userType = data && data.user_type
//     if (userType === "mentor") {
//       setVerifiedAsMentor(true)
//     }
//     else if (userType === "admin") {
//       setVerifiedAsAdmin(true)
//     } else if (userType === "BDE") {
//       setVerifiedAsBDE(true)
//     }
//   }


//   return (
//     <div className="font-gilroy font-medium text-gray text-lg leading-[27px]">
//       <ToastContainer />
//       {/* <AuthenticationState.Provider value={{ userAuthenticated, setuserAuthenticated, verifiedAsMentor, setVerifiedAsMentor, verifiedAsAdmin, setVerifiedAsAdmin }}> */}
//       <AuthenticationState.Provider value={{ 
//   userAuthenticated, 
//   setuserAuthenticated: (value) => {
//     setuserAuthenticated(value);
//     if (value) {
//       navigate("/codomo/home");
//     }
//   }, 
//   verifiedAsMentor, 
//   setVerifiedAsMentor, 
//   verifiedAsAdmin, 
//   setVerifiedAsAdmin 
// }}>
    
//   {/* These should be public routes - no authentication check */}
//   <Routes>
//   {/* PUBLIC ROUTES - No authentication needed */}
//   <Route path="/signIn" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignIn />} />
//   <Route path="/signUp" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignUp />} />
//   <Route path="/confirmemail" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <EmailConfirm />} />
  
//   {/* ROOT PATH - Redirect to signIn */}
//   <Route path="/" element={<Navigate to="/signIn" />} />
//   <Route path="/home" element={<Navigate to="/signIn" />} /> {/* ← ADD THIS to catch /home */}
  
//   {/* PROTECTED ROUTES - Need authentication */}
//   <Route path="/codomo/home" element={userAuthenticated ? <HomePage /> : <Navigate to="/signIn" />} />
//   <Route path="/codomo/landing" element={userAuthenticated ? <AboutOne /> : <Navigate to="/signIn" />} />
//   <Route path="/codomo/course" element={userAuthenticated ? <Course /> : <Navigate to="/signIn" />} />
//           {/* <Route path="/codomo/home" element={userAuthenticated ? <HomePage /> : <Authentication />} />
//           <Route path="/codomo/landing" element={userAuthenticated ? <AboutOne /> : <Authentication />} />
//           <Route path="/codomo/course" element={userAuthenticated ? <Course /> : <Authentication />} /> */}
//           <Route path="/codomo/home" element={userAuthenticated ? <HomePage /> : <Navigate to="/signIn" />} />
// <Route path="/codomo/landing" element={userAuthenticated ? <AboutOne /> : <Navigate to="/signIn" />} />
// <Route path="/codomo/course" element={userAuthenticated ? <Course /> : <Navigate to="/signIn" />} />
//           <Route path="/codomo/contactus" element={userAuthenticated ? <ContactUs /> : <Authentication />} />
//           <Route path="/codomo/course/downloads" element={userAuthenticated ? <Downloads /> : <Authentication />} />
//           <Route path="/codomo/blog" element={userAuthenticated ? <Blog /> : <Authentication />} />
//           <Route path="/codomo/editprofile" element={userAuthenticated ? <EditProfile /> : <Authentication />} />
//           <Route path="/codomo/codeeditor" element={userAuthenticated ? <AdvancedCourse /> : <Authentication />} />
//           <Route path="/codomo/popup" element={userAuthenticated ? <Popup /> : <Authentication />} />
//           <Route path="/codomo/ActivityOne" element={userAuthenticated ? <ActivityOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityOneOne" element={userAuthenticated ? <ActivityOneOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityTwo" element={userAuthenticated ? <ActivityTwo /> : <Authentication />} />
//           <Route path="/codomo/ActivityTwoOne" element={userAuthenticated ? <ActivityTwoOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityThree" element={userAuthenticated ? <ActivityThree /> : <Authentication />} />
//           <Route path="/codomo/StoryTellerActivity" element={userAuthenticated ? <StoryTellerActivity /> : <Authentication />} />
//           <Route path="/codomo/StoryTellerActivityOne" element={userAuthenticated ? <StoryTellerActivityOne /> : <Authentication />} />
//           <Route path="/codomo/ActivitySeven" element={userAuthenticated ? <ActivitySeven /> : <Authentication />} />
//           <Route path="/codomo/ActivityEight" element={userAuthenticated ? <ActivityEight /> : <Authentication />} />
//           <Route path="/codomo/ActivityNine" element={userAuthenticated ? <ActivityNine /> : <Authentication />} />
//           <Route path="/codomo/ActivityFour" element={userAuthenticated ? <ActivityFour /> : <Authentication />} />
//           <Route path="/codomo/ActivityFive" element={userAuthenticated ? <ActivityFive /> : <Authentication />} />
//           <Route path="/codomo/ActivitySix" element={userAuthenticated ? <ActivitySix /> : <Authentication />} />
//           <Route path="/codomo/ActivityTen" element={userAuthenticated ? <ActivityTen /> : <Authentication />} />
//           <Route path="/codomo/ActivityEleven" element={userAuthenticated ? <ActivityEleven /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionone" element={userAuthenticated ? <AppLabSessionone /> : <Authentication />} />
//           <Route path="/codomo/Webusb" element={userAuthenticated ? <Webusb /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionthree" element={userAuthenticated ? <AppLabSessionthree /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionfour" element={userAuthenticated ? <AppLabSessionfour /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionfive" element={userAuthenticated ? <AppLabSessionfive /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionsix" element={userAuthenticated ? <AppLabSessionsix /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionseven" element={userAuthenticated ? <AppLabSessionseven /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessioneight" element={userAuthenticated ? <AppLabSessioneight /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionnine" element={userAuthenticated ? <AppLabSessionnine /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionten" element={userAuthenticated ? <AppLabSessionten /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessioneleven" element={userAuthenticated ? <AppLabSessioneleven /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Index1" element={userAuthenticated ? <Index1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Index2" element={userAuthenticated ? <Index2 /> : <Authentication />} />
//           <Route path="/codomo/onecompiler" element={userAuthenticated ? <OneCompilerIframe /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack1" element={userAuthenticated ? <Backtrack1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack2" element={userAuthenticated ? <Backtrack2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack3" element={userAuthenticated ? <Backtrack3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation2" element={userAuthenticated ? <Estimation2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation1" element={userAuthenticated ? <Estimation1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation3" element={userAuthenticated ? <Estimation3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Complement1" element={userAuthenticated ? <Complement1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Complement2" element={userAuthenticated ? <Complement2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Dh" element={userAuthenticated ? <Dh /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count" element={userAuthenticated ? <Count /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count2s" element={userAuthenticated ? <Count2s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count10s" element={userAuthenticated ? <Count10s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count100s" element={userAuthenticated ? <Count100s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divisible3" element={userAuthenticated ? <Divisible3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divisible" element={userAuthenticated ? <Divisible /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Factors" element={userAuthenticated ? <Factors /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Factors2" element={userAuthenticated ? <Factors2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Grouping1" element={userAuthenticated ? <Grouping1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Rounding" element={userAuthenticated ? <Rounding1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Rounding2" element={userAuthenticated ? <Rounding2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Angles2" element={userAuthenticated ? <Angles2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Shapetrain" element={userAuthenticated ? <Shapetrain /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Shapes" element={userAuthenticated ? <Shapes /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Task2" element={userAuthenticated ? <Task2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Task3" element={userAuthenticated ? <Task3 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/Newactivityone" element={userAuthenticated ? <Newactivityone /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Newactivitytwo" element={userAuthenticated ? <Newactivitytwo /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Newactivitythree" element={userAuthenticated ? <Newactivitythree /> : <Authentication />} />




//           <Route path="/codomo/mentalmath/Indexl1" element={userAuthenticated ? <Indexl1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Indexl2" element={userAuthenticated ? <Indexl2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr1" element={userAuthenticated ? <Lr1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr2" element={userAuthenticated ? <Lr2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr3" element={userAuthenticated ? <Lr3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Halving" element={userAuthenticated ? <Halving /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Placevalue" element={userAuthenticated ? <Placevalue /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Placevalue2" element={userAuthenticated ? <Placevalue2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/placevalue3" element={userAuthenticated ? <Placevalue3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/placevalue4" element={userAuthenticated ? <Placevalue4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divible2" element={userAuthenticated ? <Divisible2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple1" element={userAuthenticated ? <Multiple1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple2" element={userAuthenticated ? <Multiple2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple3" element={userAuthenticated ? <Multiple3 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/Compositesmash" element={userAuthenticated ? <Compositesmash /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Prime" element={userAuthenticated ? <Prime /> : <Authentication />} />



//           <Route path="/codomo/mentalmath/lthree/Session172" element={userAuthenticated ? <Session172 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session141" element={userAuthenticated ? <Session141 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session15" element={userAuthenticated ? <Session15 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session152" element={userAuthenticated ? <Session152 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session16" element={userAuthenticated ? <Session16 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session162" element={userAuthenticated ? <Session162 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session171" element={userAuthenticated ? <Session171 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session142" element={userAuthenticated ? <Session142 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Factors21" element={userAuthenticated ? <Factors21 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Multiplynew" element={userAuthenticated ? < Multiplynew /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Twodigit" element={userAuthenticated ? <Twodigit /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Twodigitb" element={userAuthenticated ? <Twodigitb /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level2/Level5quiz" element={userAuthenticated ? <Level5quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level4quiz" element={userAuthenticated ? <Level4quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level3quiz" element={userAuthenticated ? <Level3quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level2quiz" element={userAuthenticated ? <Level2quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level1quiz" element={userAuthenticated ? <Level1quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Subtract1000" element={userAuthenticated ? <Subtract1000 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Subtract10000" element={userAuthenticated ? <Subtract10000 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Integer2" element={userAuthenticated ? <Integer2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Halfoften" element={userAuthenticated ? <Halfof /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session9" element={userAuthenticated ? <Session9 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session9part2" element={userAuthenticated ? <Session9part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11" element={userAuthenticated ? <Session11 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11part3" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Sessionpart3" element={userAuthenticated ? <Session11part3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Sessionpart4" element={userAuthenticated ? <Session11part4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session10" element={userAuthenticated ? <Session10 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11part2" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session8" element={userAuthenticated ? <Session8 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session7" element={userAuthenticated ? <Session7 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level2/Oneandhalf" element={userAuthenticated ? <Oneandhalf /> : <Authentication />} />



//           <Route path="/codomo/mentalmath/level4/Magicsquare" element={userAuthenticated ? <Magicsquare /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Proportion" element={userAuthenticated ? <Proportion /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Ratio" element={userAuthenticated ? <Ratio /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Scaling" element={userAuthenticated ? <Scaling /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Gessop" element={userAuthenticated ? <Gessop /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Nameriddle" element={userAuthenticated ? <Nameriddle /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level4/Sessions20v4" element={userAuthenticated ? <Sessions20v4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Start" element={userAuthenticated ? <Start /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level4/Start/Tc1" element={userAuthenticated ? <TC1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Start/Tc2" element={userAuthenticated ? <TC2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Tc3" element={userAuthenticated ? <TC3 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level4/Sessions19v1" element={userAuthenticated ? <Sessions19v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions19v2" element={userAuthenticated ? <Sessions19v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions19v3" element={userAuthenticated ? <Sessions19v3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v1" element={userAuthenticated ? <Sessions20v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v2" element={userAuthenticated ? <Sessions20v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v3" element={userAuthenticated ? <Sessions20v3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v5" element={userAuthenticated ? <Sessions20v5 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions21v1" element={userAuthenticated ? <Sessions21v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions21v2" element={userAuthenticated ? <Sessions21v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Activity1" element={userAuthenticated ? <Activity1 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Angle" element={userAuthenticated ? <Angle /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Time" element={userAuthenticated ? <Time /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement" element={userAuthenticated ? <Measurement /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/lfive/Measurement/level1" element={userAuthenticated ? <Level1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level2" element={userAuthenticated ? <Level2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level3" element={userAuthenticated ? <Level3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level4" element={userAuthenticated ? <Level4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level5" element={userAuthenticated ? <Level5 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival" element={userAuthenticated ? <Divisoncarnival /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival2" element={userAuthenticated ? <Divisoncarnival2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival2" element={userAuthenticated ? <Divisoncarnival2 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Meterandcm" element={userAuthenticated ? <Meterandcm /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Percentnew" element={userAuthenticated ? <Percentnew /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Weight" element={userAuthenticated ? <Weight /> : <Authentication />} />


//           <Route path="/codomo/mentalmath/level7/Binaryone" element={userAuthenticated ? <L7aone /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Binarytwo" element={userAuthenticated ? <L7atwo /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Binarythree" element={userAuthenticated ? <L7athree /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Security" element={userAuthenticated ? <L7afour /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Activity5" element={userAuthenticated ? <L7afive /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Activity6" element={userAuthenticated ? <L7asix /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/Bargraph2" element={userAuthenticated ? <Bargraph2 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Bargraph" element={userAuthenticated ? <Bargraph /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Datainterpretation" element={userAuthenticated ? <Datainterpretation /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Matchpiechart" element={userAuthenticated ? <MatchPieChart /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Mean" element={userAuthenticated ? <Mean /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Median" element={userAuthenticated ? <Median /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Mode" element={userAuthenticated ? <Mode /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Piechart" element={userAuthenticated ? <Piechart /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Puzzlepiechart" element={userAuthenticated ? <Puzzlepiechart /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Survey" element={userAuthenticated ? <Survey /> : <Authentication />} />


//           <Route path="/codomo/IntermediateAi/Activity1" element={userAuthenticated ? <Activity11 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity12" element={userAuthenticated ? <Activity12 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity13" element={userAuthenticated ? <Activity13 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity14" element={userAuthenticated ? <Activity14 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity15" element={userAuthenticated ? <Activity15 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity16" element={userAuthenticated ? <Activity16 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity17" element={userAuthenticated ? <Activity17 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity18" element={userAuthenticated ? <Activity18 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity19" element={userAuthenticated ? <Activity19 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity20" element={userAuthenticated ? <Activity20 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity21" element={userAuthenticated ? <Activity21 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity22" element={userAuthenticated ? <Activity22 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity23" element={userAuthenticated ? <Activity23 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity24" element={userAuthenticated ? <Activity24 /> : <Authentication />} />


//           <Route path="/codomo/Digitalbasics/Digital1" element={userAuthenticated ? <Digital1 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital2" element={userAuthenticated ? <Digital2 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital3" element={userAuthenticated ? <Digital3 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital4" element={userAuthenticated ? <Digital4 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital5" element={userAuthenticated ? <Digital5 /> : <Authentication />} />
//           {/* <Route path="/codomo/Digitalbasics/Digital5" element={userAuthenticated ? <Digital5 /> : <Authentication />} /> */}
//           <Route path="/codomo/Digitalbasics/Digital6" element={userAuthenticated ? <Digital6 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital7" element={userAuthenticated ? <Digital7 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital9" element={userAuthenticated ? <Digital9 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital10" element={userAuthenticated ? <Digital10 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital11" element={userAuthenticated ? <Digital11 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital12" element={userAuthenticated ? <Digital12 /> : <Authentication />} />


//           <Route path="/codomo/mentor/activities" element={userAuthenticated ? verifiedAsMentor ? <MentorActivities /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           {/* <Route path="/codomo/mentor/addbatch" element={userAuthenticated ? verifiedAsAdmin ? <AddBatch /> : <Navigate to="/codomo/home"/> : <Authentication />} /> */}
//           <Route path="/codomo/mentor/notification" element={userAuthenticated ? verifiedAsMentor ? <NotificationService /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/admiration" element={userAuthenticated ? verifiedAsMentor ? <Admiration /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/dashboard" element={userAuthenticated ? verifiedAsMentor ? <Dashboard /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           {/* <Route path="/codomo/mentor/addstudent" element={userAuthenticated ?verifiedAsAdmin ?<AddStudent /> : <Navigate to="/codomo/home"/> : <Authentication />} /> */}
//           <Route path="/codomo/mentor/addblog" element={userAuthenticated ? verifiedAsMentor ? <AddBlog /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/editbatch" element={userAuthenticated ? <EditBatch /> : <Authentication />} />

//           <Route path="/codomo/Gcse/TraceTable" element={userAuthenticated ? <TraceTable /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Flowchart" element={userAuthenticated ? <Flowchart /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Break" element={userAuthenticated ? <Break /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Binarytodecimal" element={userAuthenticated ? <Binarytodecimal /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Hexadecimal" element={userAuthenticated ? <Hexadecimal /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Decimaltobinary" element={userAuthenticated ? <Decimaltobinary /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Unicode" element={userAuthenticated ? <Unicode /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Pixelart" element={userAuthenticated ? <Pixelart /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Sound" element={userAuthenticated ? <Sound /> : <Authentication />} />

//           <Route path="/codomo/Gcse/Ascii" element={userAuthenticated ? <Ascii /> : <Authentication />} />



//           <Route path="/codomo/admin/createbatch" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           {/* <Route path="/codomo/admin/DemoDetails" element={userAuthenticated ? verifiedAsAdmin || verifiedAsBDE ? <DemoDetails /> : <Navigate to="/codomo/home" /> : <Authentication />} /> */}
//           {/* <Route path="/codomo/admin/DemoDetailsForm" element={userAuthenticated ? verifiedAsAdmin || verifiedAsBDE ? <DemoDetailsForm /> : <Navigate to="/codomo/home" /> : <Authentication />} /> */}

//           <Route path="/codomo/admin/addbatch" element={userAuthenticated ? verifiedAsAdmin ? <AddBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/addstudent" element={userAuthenticated ? verifiedAsAdmin ? <AddStudent /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/usermanagement" element={userAuthenticated ? verifiedAsAdmin ? <UserManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/createnewuser" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewUser /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/coursemanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/createnewcourse" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewCourse /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/activitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <ActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/downloadsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseDownloadsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/subactivitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <SubActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/mappingmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseMappingManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/assiginingcoursetomentor" element={userAuthenticated ? verifiedAsAdmin ? <AssiginingCourseToMentor /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/batchmanagement" element={userAuthenticated ? verifiedAsAdmin ? <BatchManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/assignBatch" element={<AssignBatchToTheMentor />} />
//           <Route path="/codomo/admin/accountsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <AccountsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />



//           <Route path="/" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/confirmemail" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <EmailConfirm />} />
//           <Route path="/signIn" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignIn />} />
//           <Route path="/signUp" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignUp />} />
//           <Route path="/videoCallActivity" element={<VideoCallActivity />} />
//           <Route path="/voiceCallActivity" element={<VoiceCallActivity />} />
//           <Route path="/chatScreen" element={<ChatScreen />} />
//           <Route path="/googleMeet" element={<GoogleMeet />} />




//           <Route path="*" element={<ErrorPage />} />
//         </Routes>
//       </AuthenticationState.Provider>
//     </div>
//   );
// }

// export default App;





























// import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";
// import React, { useEffect, useState, createContext, useContext } from 'react';
// import HomePage from "./Components/MainPage/HomePage";
// import SignIn from "./Components/MainPage/SignIn";
// import SignUp from "./Components/MainPage/SignUp"
// import Course from "./Components/MainPage/Course";
// import AboutOne from "./Components/MainPage/AboutOne"
// import EmailConfirm from "./Components/MainPage/EmailConfirm";
// import ContactUs from "./Components/MainPage/ContactUs"
// import Downloads from "./Components/MainPage/Downloads"
// import ErrorPage from "./Components/404ErrorPage";
// import MentorActivities from "./Components/MainPage/MentorActivities";
// import Authentication from "./Components/Authentication/Authentication";
// import AddBatch from "./Components/MainPage/AddBatch";
// import AddStudent from "./Components/MainPage/AddStudent"
// import Blog from "./Components/MainPage/Blog"
// import AddBlog from "./Components/MainPage/AddBlog";
// import EditBatch from "./Components/MainPage/EditBatch";
// import EditProfile from "./Components/MainPage/EditProfile";
// import UserManagement from "./Components/MainPage/UserManagement";
// import CreateNewUser from "./Components/MainPage/CreateNewUser";
// import CourseManagement from "./Components/MainPage/CourseManagement";
// import CreateNewCourse from "./Components/MainPage/CreateNewCourse";
// import ActivityManagement from "./Components/MainPage/ActivityManagement";
// import CourseDownloadsManagement from "./Components/MainPage/CourseDownloadsManagement";
// import SubActivityManagement from "./Components/MainPage/SubActivityManagement";
// import AdvancedCourse from "./Components/MainPage/AdvancedCourse";
// import CourseMappingManagement from "./Components/MainPage/CourseMappingManagement";
// import OneCompilerIframe from "./Components/MainPage/OneCompilerIframe";
// import Admiration from "./Components/MainPage/Admiration";
// import Popup from "./Components/MainPage/Popup";
// import NotificationService from "./Components/MainPage/NotificationService";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { AuthenticateUser, FetchHomePageDetails } from './api/aws-api';
// import { ConstructorEventPost, ConstructorEventGet } from './Event/event';
// import ActivityOne from "./Components/MainPage/ActivityOne";
// import ActivityOneOne from "./Components/MainPage/ActivityOneOne";
// import ActivityTwo from "./Components/MainPage/ActivityTwo";
// import ActivityTwoOne from "./Components/MainPage/ActivityTwoOne";
// import ActivityThree from "./Components/MainPage/ActivityThree";
// import ActivityFour from "./Components/MainPage/ActivityFour";
// import ActivityNine from "./Components/MainPage/ActivityNine";
// import StoryTellerActivity from "./Components/MainPage/StoryTellerActivity";
// import StoryTellerActivityOne from "./Components/MainPage/StoryTellerActivityOne";
// import ActivitySeven from "./Components/MainPage/ActivitySeven"
// import ActivityEight from "./Components/MainPage/ActivityEight"
// import ActivityFive from "./Components/MainPage/ActivityFive"
// import ActivitySix from "./Components/MainPage/ActivitySix"
// import ActivityTen from "./Components/MainPage/ActivityTen"
// import ActivityEleven from "./Components/MainPage/ActivityEleven"
// import AppLabSessionone from "./Components/MainPage/AppLabSessionone"
// import AppLabSessionthree from "./Components/MainPage/AppLabSessionthree"
// import Webusb from "./Components/MainPage/Webusb"
// import AppLabSessionfour from "./Components/MainPage/AppLabSessionfour"
// import AppLabSessionfive from "./Components/MainPage/AppLabSessionfive"
// import AppLabSessionsix from "./Components/MainPage/AppLabSessionsix"
// import AppLabSessionseven from "./Components/MainPage/AppLabSessionseven"
// import AppLabSessioneight from "./Components/MainPage/AppLabSessioneight"
// import AppLabSessionnine from "./Components/MainPage/AppLabSessionnine"
// import AppLabSessionten from "./Components/MainPage/AppLabSessionten"
// import AssiginingCourseToMentor from "./Components/MainPage/AssiginingCourseToMentor"
// import AppLabSessioneleven from "./Components/MainPage/AppLabSessioneleven"
// import VideoCallActivity from "./Components/MainPage/VideoCallActivity";
// import VoiceCallActivity from "./Components/MainPage/VoiceCallActivity";
// import ChatScreen from "./Components/MainPage/ChatScreen";
// import GoogleMeet from "./Components/MainPage/GoogleMeet";
// import BatchManagement from "./Components/MainPage/BatchManagement";
// import AssignBatchToTheMentor from "./Components/MainPage/AssignBatchToMentor";
// import AccountsManagement from "./Components/MainPage/AccountsManagement";
// import CreateNewBatch from "./Components/MainPage/CreateNewBatch";

// // ------------------------------------------------------------------------------------------

// import Index1 from "./Components/MainPage/mentalmath/Index1";
// import Index2 from "./Components/MainPage/mentalmath/Index2";
// import Placevalue from "./Components/MainPage/mentalmath/Placevalue";
// import Placevalue2 from "./Components/MainPage/mentalmath/Placevalue2";
// import Placevalue3 from "./Components/MainPage/mentalmath/Placevalue3";
// import Placevalue4 from "./Components/MainPage/mentalmath/Placevalue4";
// import Divisible2 from "./Components/MainPage/mentalmath/Divisible2"
// import Multiple1 from "./Components/MainPage/mentalmath/Multiple"
// import Multiple2 from "./Components/MainPage/mentalmath/Multiple2"
// import Multiple3 from "./Components/MainPage/mentalmath/multiple3"
// import Newactivityone from "./Components/MainPage/mentalmath/Newactivityone"
// import Newactivitytwo from "./Components/MainPage/mentalmath/Newactivitytwo"
// import Newactivitythree from "./Components/MainPage/mentalmath/Newactivitythree"


// import Halving from "./Components/MainPage/mentalmath/Halving"
// import Backtrack1 from "./Components/MainPage/mentalmath/Backtrack1";
// import Backtrack2 from "./Components/MainPage/mentalmath/Backtrack2";
// import Backtrack3 from "./Components/MainPage/mentalmath/Backtrack3";
// import Compositesmash from "./Components/MainPage/mentalmath/Compositesmash";
// import Prime from "./Components/MainPage/mentalmath/Prime";
// import Angles2 from "./Components/MainPage/mentalmath/Angles2";
// import Shapetrain from "./Components/MainPage/mentalmath/Shapetrain";
// import Shapes from "./Components/MainPage/mentalmath/Shapes";
// import Task2 from "./Components/MainPage/mentalmath/Task2";
// import Task3 from "./Components/MainPage/mentalmath/Task3";



// import Estimation2 from "./Components/MainPage/mentalmath/Estimation2";
// import Estimation1 from "./Components/MainPage/mentalmath/Estimation1";
// import Estimation3 from "./Components/MainPage/mentalmath/Estimation3";
// import Complement1 from "./Components/MainPage/mentalmath/Complement1";
// import Complement2 from "./Components/MainPage/mentalmath/Complement2";
// import Count from "./Components/MainPage/mentalmath/Count";
// import Dh from "./Components/MainPage/mentalmath/Dh";

// import Divisible3 from "./Components/MainPage/mentalmath/Divisible3";
// import Divisible from "./Components/MainPage/mentalmath/Divisible";
// import Indexl2 from "./Components/MainPage/mentalmath/Indexl2";
// import Indexl1 from "./Components/MainPage/mentalmath/Indexl1";
// import Lr1 from "./Components/MainPage/mentalmath/Lr1";
// import Lr2 from "./Components/MainPage/mentalmath/Lr2";
// import Lr3 from "./Components/MainPage/mentalmath/Lr3";
// import Rounding1 from "./Components/MainPage/mentalmath/Rounding1";
// import Rounding2 from "./Components/MainPage/mentalmath/Rounding2";

// import Factors from "./Components/MainPage/mentalmath/Factors";
// import Factors2 from "./Components/MainPage/mentalmath/Factors2";
// import Grouping1 from "./Components/MainPage/mentalmath/Grouping1";
// import Session141 from './Components/MainPage/mentalmath/lthree/Session141';
// import Session142 from './Components/MainPage/mentalmath/lthree/Session142';
// import Session15 from './Components/MainPage/mentalmath/lthree/Session15';
// import Session152 from './Components/MainPage/mentalmath/lthree/Session152';
// import Factors21 from './Components/MainPage/mentalmath/lthree/Factors21'

// import Session16 from './Components/MainPage/mentalmath/lthree/Session16'
// import Session162 from './Components/MainPage/mentalmath/lthree/Session162'
// import Session172 from './Components/MainPage/mentalmath/lthree/Session172'
// import Session171 from './Components/MainPage/mentalmath/lthree/Session171';
// import Halfof from "./Components/MainPage/mentalmath/level2/Halfsofhtml"
// import Session9 from "./Components/MainPage/mentalmath/level2/Session9"
// import Session9part2 from "./Components/MainPage/mentalmath/level2/Session9part2"
// import Session10 from "./Components/MainPage/mentalmath/level2/Sesssion10"
// import Session11 from "./Components/MainPage/mentalmath/level2/Session11"
// import Session11part2 from "./Components/MainPage/mentalmath/level2/Session11part2"
// import Session11part3 from "./Components/MainPage/mentalmath/level2/Session11part3"
// import Session11part4 from "./Components/MainPage/mentalmath/level2/Session11part4"
// import Session7 from "./Components/MainPage/mentalmath/level2/Sessions7"
// import Session8 from "./Components/MainPage/mentalmath/level2/Sessions8v2"
// import Integer2 from "./Components/MainPage/mentalmath/level2/Interger2"
// import Subtract1000 from "./Components/MainPage/mentalmath/level2/Subtract1000"
// import Subtract10000 from "./Components/MainPage/mentalmath/level2/Subtract10000"
// import Oneandhalf from "./Components/MainPage/mentalmath/level2/Oneandhalf"
// import Level1quiz from "./Components/MainPage/mentalmath/level2/Level1quiz"
// import Level2quiz from "./Components/MainPage/mentalmath/level2/Level2quiz"
// import Level3quiz from "./Components/MainPage/mentalmath/level2/Level3quiz"
// import Level4quiz from "./Components/MainPage/mentalmath/level2/Level4quiz"
// import Level5quiz from "./Components/MainPage/mentalmath/level2/Level5quiz"
// import Multiplynew from "./Components/MainPage/mentalmath/level2/Newactivitymultiply"
// import Twodigit from "./Components/MainPage/mentalmath/level2/Twodigit"
// import Twodigitb from "./Components/MainPage/mentalmath/level2/Twodigitb"



// import Sessions20v4 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
// import Sessions19v1 from "./Components/MainPage/mentalmath/level4/Sessions19v1"
// import Sessions19v2 from "./Components/MainPage/mentalmath/level4/Sessions19v2"
// import Sessions19v3 from "./Components/MainPage/mentalmath/level4/Sessions19v3"
// import Sessions20v1 from "./Components/MainPage/mentalmath/level4/Sessions20v1"
// import Sessions20v2 from "./Components/MainPage/mentalmath/level4/Sessions20v2"
// import Sessions20v3 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
// import Sessions20v5 from "./Components/MainPage/mentalmath/level4/Sessions20v5"
// import Sessions21v1 from "./Components/MainPage/mentalmath/level4/Sessions21v1"
// import Sessions21v2 from "./Components/MainPage/mentalmath/level4/Sessions21v2"
// import Magicsquare from "./Components/MainPage/mentalmath/level4/Magicsquare"
// import Proportion from "./Components/MainPage/mentalmath/level4/Proportion"
// import Scaling from "./Components/MainPage/mentalmath/level4/Scaling"
// import Ratio from "./Components/MainPage/mentalmath/level4/Ratio"
// import Gessop from "./Components/MainPage/mentalmath/level4/Gessop"
// import Nameriddle from './Components/MainPage/mentalmath/level4/Nameriddle'
// import TC1 from "./Components/MainPage/mentalmath/level4/Tc1"
// import TC2 from "./Components/MainPage/mentalmath/level4/Tc2"
// import TC3 from "./Components/MainPage/mentalmath/level4/Tc3"
// import Start from "./Components/MainPage/mentalmath/level4/start1"


// import Activity1 from "./Components/MainPage/mentalmath/lfive/Activity1";
// import Activity2 from "./Components/MainPage/mentalmath/lfive/Activity2";
// import Angle from "./Components/MainPage/mentalmath/lfive/Angle";
// import Measurement from "./Components/MainPage/mentalmath/lfive/Measurement";
// import Level1 from "./Components/MainPage/mentalmath/lfive/Level1";
// import Level2 from "./Components/MainPage/mentalmath/lfive/Level2";
// import Level3 from "./Components/MainPage/mentalmath/lfive/Level3";
// import Level4 from "./Components/MainPage/mentalmath/lfive/Level4";
// import Level5 from "./Components/MainPage/mentalmath/lfive/Level5";
// import Time from "./Components/MainPage/mentalmath/lfive/Time";
// import Divisoncarnival from "./Components/MainPage/mentalmath/lfive/Divisoncarnival";
// import Divisoncarnival2 from "./Components/MainPage/mentalmath/lfive/Divisoncarnival2";
// import Meterandcm from "./Components/MainPage/mentalmath/lfive/Meterandcm";
// import Percentnew from "./Components/MainPage/mentalmath/lfive/percentnew";
// import Weight from "./Components/MainPage/mentalmath/lfive/Weight";

// import Bargraph2 from "./Components/MainPage/mentalmath/level6/Bargraph2"
// import Bargraph from "./Components/MainPage/mentalmath/level6/Bargraph"
// import Datainterpretation from "./Components/MainPage/mentalmath/level6/Datainterpretation"
// import MatchPieChart from "./Components/MainPage/mentalmath/level6/Matchpiechart";
// import Mean from "./Components/MainPage/mentalmath/level6/Mean"
// import Median from "./Components/MainPage/mentalmath/level6/Median"
// import Mode from "./Components/MainPage/mentalmath/level6/Mode"
// import Piechart from "./Components/MainPage/mentalmath/level6/Piechart"
// import Puzzlepiechart from "./Components/MainPage/mentalmath/level6/Puzzlepiechart"
// import Survey from "./Components/MainPage/mentalmath/level6/Survey"
// import L7aone from "./Components/MainPage/mentalmath/level7/Activityone"
// import L7atwo from "./Components/MainPage/mentalmath/level7/Activitytwo"
// import L7athree from "./Components/MainPage/mentalmath/level7/Activitythree"
// import L7afour from "./Components/MainPage/mentalmath/level7/Activity4"
// import L7afive from "./Components/MainPage/mentalmath/level7/Activity5"
// import L7asix from "./Components/MainPage/mentalmath/level7/Activity6"




// import Activity11 from "./Components/MainPage/IntermediateAi/Activity1"
// import Activity12 from "./Components/MainPage/IntermediateAi/Activity2"
// import Activity13 from "./Components/MainPage/IntermediateAi/Activity3"
// import Activity14 from "./Components/MainPage/IntermediateAi/Activity4"
// import Activity15 from "./Components/MainPage/IntermediateAi/Activity5"
// import Activity16 from "./Components/MainPage/IntermediateAi/Activity6"
// import Activity17 from "./Components/MainPage/IntermediateAi/Activity7"
// import Activity18 from "./Components/MainPage/IntermediateAi/Activity8"
// import Activity19 from "./Components/MainPage/IntermediateAi/Activity9"
// import Activity20 from "./Components/MainPage/IntermediateAi/Activity10"
// import Activity21 from "./Components/MainPage/IntermediateAi/Activity11"
// import Activity22 from "./Components/MainPage/IntermediateAi/Activity12"
// import Activity23 from "./Components/MainPage/IntermediateAi/Activity13"
// import Activity24 from "./Components/MainPage/IntermediateAi/Activity14"

// import Digital1 from "./Components/MainPage/Digitalbasics/Digital1"
// import Digital2 from "./Components/MainPage/Digitalbasics/Digital2"
// import Digital3 from "./Components/MainPage/Digitalbasics/Digital3"
// import Digital4 from "./Components/MainPage/Digitalbasics/Digital4"
// import Digital5 from "./Components/MainPage/Digitalbasics/Digital5"
// import Digital6 from "./Components/MainPage/Digitalbasics/Digital6"
// import Digital7 from "./Components/MainPage/Digitalbasics/Digital7"
// import Digital9 from "./Components/MainPage/Digitalbasics/Digital9"
// import Digital10 from "./Components/MainPage/Digitalbasics/Digital10"
// import Digital11 from "./Components/MainPage/Digitalbasics/Digital11"
// import Digital12 from "./Components/MainPage/Digitalbasics/Digital12"

// import Count2s from "./Components/MainPage/mentalmath/Count2s"
// import Count10s from "./Components/MainPage/mentalmath/Count10s"
// import Count100s from "./Components/MainPage/mentalmath/Count100s"
// import Dashboard from "./Components/MainPage/Dashboard";

// import Break from "./Components/MainPage/Gcs/Break";
// import Flowchart from "./Components/MainPage/Gcs/Flowchart";
// import TraceTable from "./Components/MainPage/Gcs/TraceTable";
// import Binarytodecimal from "./Components/MainPage/Gcs/Binarytodecimal";
// import Decimaltobinary from "./Components/MainPage/Gcs/Decimaltobinary";
// import Hexadecimal from "./Components/MainPage/Gcs/Hexadecimal";
// import Unicode from "./Components/MainPage/Gcs/Unicode";
// import Pixelart from "./Components/MainPage/Gcs/Pixelart";
// import Ascii from "./Components/MainPage/Gcs/Ascii";
// import Sound from "./Components/MainPage/Gcs/Sound";



// export const AuthenticationState = createContext();

// function App() {
  
//   const [userAuthenticated, setuserAuthenticated] = useState(false)
//   const [verifiedAsMentor, setVerifiedAsMentor] = useState(false)
//   const [verifiedAsAdmin, setVerifiedAsAdmin] = useState(false)
//   const [verifiedAsBDE, setVerifiedAsBDE] = useState(false)
//   const location = useLocation();
//   const navigate = useNavigate()

//   useEffect(() => {
//     if (location.pathname !== "/signUp") {
//       const lastLoginTime = localStorage.getItem('lastLoginTime')
//       const authToken = localStorage.getItem('authToken')
//       console.log(location.pathname)
//       console.log("triggered")
//       if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && !userAuthenticated) {
//         CheckStatus(authToken)
//         console.log("app triggered")
//       }
//       else if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && userAuthenticated) { }
//       else if (authToken && (Date.now() - lastLoginTime) > 24 * 60 * 120 * 1000 && userAuthenticated) {
//         setuserAuthenticated(false)
//         navigate("/signIn")
//         console.log("user time out")
//       }
//       else {
//         setuserAuthenticated(false)
//       }
//     }
//   }, [location.pathname,  userAuthenticated]
//   );


//   const CheckStatus = async (authToken) => {
//   const storedData = localStorage.getItem('UserKey');
  
//   if (!storedData || storedData === "undefined" || storedData === "null") {
//     setuserAuthenticated(false);
//     navigate("/signIn");
//     return;
//   }

//   try {
//     const params = JSON.parse(storedData);
//     fetchdata(params);
//     params["authToken"] = authToken;
    
//     const timeoutPromise = new Promise((_, reject) =>
//       setTimeout(() => reject(new Error('timeout')), 10000)
//     );
    
//     const responsedata = await Promise.race([
//       ConstructorEventPost(AuthenticateUser, params),
//       timeoutPromise
//     ]);
    
//     if (responsedata === "authentication_success") {
//       setuserAuthenticated(true);
//       // Only navigate if we're not already on home
//       if (location.pathname !== "/codomo/home") {
//         navigate("/codomo/home");
//       }
//     } else {
//       // Authentication failed - clear session and go to signIn
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('lastLoginTime');
//       localStorage.removeItem('UserKey');
//       setuserAuthenticated(false);
//       navigate("/signIn");
//     }
//   } catch (e) {
//     console.warn("CheckStatus failed:", e);
//     // On error, clear session to prevent infinite loop
//     localStorage.removeItem('authToken');
//     localStorage.removeItem('lastLoginTime');
//     localStorage.removeItem('UserKey');
//     setuserAuthenticated(false);
//     navigate("/signIn");
//   }
// };



//   const fetchdata = async (params) => {
//     const responsedata = await ConstructorEventGet(FetchHomePageDetails, params)
//     sessionStorage.setItem('UserData', JSON.stringify(responsedata[0]))
//     checkUserType(responsedata[0])
//   }

//   function checkUserType(data) {
//     const userType = data && data.user_type
//     if (userType === "mentor") {
//       setVerifiedAsMentor(true)
//     }
//     else if (userType === "admin") {
//       setVerifiedAsAdmin(true)
//     } else if (userType === "BDE") {
//       setVerifiedAsBDE(true)
//     }
//   }


//   return (
//     <div className="font-gilroy font-medium text-gray text-lg leading-[27px]">
//       <ToastContainer />
//       <AuthenticationState.Provider value={{ 
//   userAuthenticated, 
//   setuserAuthenticated: (value) => {
//     setuserAuthenticated(value);
//     if (value) {
//       navigate("/codomo/home");
//     }
//   }, 
//   verifiedAsMentor, 
//   setVerifiedAsMentor, 
//   verifiedAsAdmin, 
//   setVerifiedAsAdmin 
// }}>
    
//   <Routes>
//           <Route path="/home" element={<Navigate to="/signIn" />} />
//           <Route path="/codomo/home" element={userAuthenticated ? <HomePage /> : <Authentication />} />
//           <Route path="/codomo/landing" element={userAuthenticated ? <AboutOne /> : <Authentication />} />
//           <Route path="/codomo/course" element={userAuthenticated ? <Course /> : <Authentication />} />
//           <Route path="/codomo/contactus" element={userAuthenticated ? <ContactUs /> : <Authentication />} />
//           <Route path="/codomo/course/downloads" element={userAuthenticated ? <Downloads /> : <Authentication />} />
//           <Route path="/codomo/blog" element={userAuthenticated ? <Blog /> : <Authentication />} />
//           <Route path="/codomo/editprofile" element={userAuthenticated ? <EditProfile /> : <Authentication />} />
//           <Route path="/codomo/codeeditor" element={userAuthenticated ? <AdvancedCourse /> : <Authentication />} />
//           <Route path="/codomo/popup" element={userAuthenticated ? <Popup /> : <Authentication />} />
//           <Route path="/codomo/ActivityOne" element={userAuthenticated ? <ActivityOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityOneOne" element={userAuthenticated ? <ActivityOneOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityTwo" element={userAuthenticated ? <ActivityTwo /> : <Authentication />} />
//           <Route path="/codomo/ActivityTwoOne" element={userAuthenticated ? <ActivityTwoOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityThree" element={userAuthenticated ? <ActivityThree /> : <Authentication />} />
//           <Route path="/codomo/StoryTellerActivity" element={userAuthenticated ? <StoryTellerActivity /> : <Authentication />} />
//           <Route path="/codomo/StoryTellerActivityOne" element={userAuthenticated ? <StoryTellerActivityOne /> : <Authentication />} />
//           <Route path="/codomo/ActivitySeven" element={userAuthenticated ? <ActivitySeven /> : <Authentication />} />
//           <Route path="/codomo/ActivityEight" element={userAuthenticated ? <ActivityEight /> : <Authentication />} />
//           <Route path="/codomo/ActivityNine" element={userAuthenticated ? <ActivityNine /> : <Authentication />} />
//           <Route path="/codomo/ActivityFour" element={userAuthenticated ? <ActivityFour /> : <Authentication />} />
//           <Route path="/codomo/ActivityFive" element={userAuthenticated ? <ActivityFive /> : <Authentication />} />
//           <Route path="/codomo/ActivitySix" element={userAuthenticated ? <ActivitySix /> : <Authentication />} />
//           <Route path="/codomo/ActivityTen" element={userAuthenticated ? <ActivityTen /> : <Authentication />} />
//           <Route path="/codomo/ActivityEleven" element={userAuthenticated ? <ActivityEleven /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionone" element={userAuthenticated ? <AppLabSessionone /> : <Authentication />} />
//           <Route path="/codomo/Webusb" element={userAuthenticated ? <Webusb /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionthree" element={userAuthenticated ? <AppLabSessionthree /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionfour" element={userAuthenticated ? <AppLabSessionfour /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionfive" element={userAuthenticated ? <AppLabSessionfive /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionsix" element={userAuthenticated ? <AppLabSessionsix /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionseven" element={userAuthenticated ? <AppLabSessionseven /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessioneight" element={userAuthenticated ? <AppLabSessioneight /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionnine" element={userAuthenticated ? <AppLabSessionnine /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionten" element={userAuthenticated ? <AppLabSessionten /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessioneleven" element={userAuthenticated ? <AppLabSessioneleven /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Index1" element={userAuthenticated ? <Index1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Index2" element={userAuthenticated ? <Index2 /> : <Authentication />} />
//           <Route path="/codomo/onecompiler" element={userAuthenticated ? <OneCompilerIframe /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack1" element={userAuthenticated ? <Backtrack1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack2" element={userAuthenticated ? <Backtrack2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack3" element={userAuthenticated ? <Backtrack3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation2" element={userAuthenticated ? <Estimation2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation1" element={userAuthenticated ? <Estimation1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation3" element={userAuthenticated ? <Estimation3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Complement1" element={userAuthenticated ? <Complement1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Complement2" element={userAuthenticated ? <Complement2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Dh" element={userAuthenticated ? <Dh /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count" element={userAuthenticated ? <Count /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count2s" element={userAuthenticated ? <Count2s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count10s" element={userAuthenticated ? <Count10s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count100s" element={userAuthenticated ? <Count100s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divisible3" element={userAuthenticated ? <Divisible3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divisible" element={userAuthenticated ? <Divisible /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Factors" element={userAuthenticated ? <Factors /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Factors2" element={userAuthenticated ? <Factors2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Grouping1" element={userAuthenticated ? <Grouping1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Rounding" element={userAuthenticated ? <Rounding1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Rounding2" element={userAuthenticated ? <Rounding2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Angles2" element={userAuthenticated ? <Angles2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Shapetrain" element={userAuthenticated ? <Shapetrain /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Shapes" element={userAuthenticated ? <Shapes /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Task2" element={userAuthenticated ? <Task2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Task3" element={userAuthenticated ? <Task3 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/Newactivityone" element={userAuthenticated ? <Newactivityone /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Newactivitytwo" element={userAuthenticated ? <Newactivitytwo /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Newactivitythree" element={userAuthenticated ? <Newactivitythree /> : <Authentication />} />




//           <Route path="/codomo/mentalmath/Indexl1" element={userAuthenticated ? <Indexl1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Indexl2" element={userAuthenticated ? <Indexl2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr1" element={userAuthenticated ? <Lr1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr2" element={userAuthenticated ? <Lr2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr3" element={userAuthenticated ? <Lr3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Halving" element={userAuthenticated ? <Halving /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Placevalue" element={userAuthenticated ? <Placevalue /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Placevalue2" element={userAuthenticated ? <Placevalue2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/placevalue3" element={userAuthenticated ? <Placevalue3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/placevalue4" element={userAuthenticated ? <Placevalue4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divible2" element={userAuthenticated ? <Divisible2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple1" element={userAuthenticated ? <Multiple1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple2" element={userAuthenticated ? <Multiple2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple3" element={userAuthenticated ? <Multiple3 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/Compositesmash" element={userAuthenticated ? <Compositesmash /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Prime" element={userAuthenticated ? <Prime /> : <Authentication />} />



//           <Route path="/codomo/mentalmath/lthree/Session172" element={userAuthenticated ? <Session172 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session141" element={userAuthenticated ? <Session141 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session15" element={userAuthenticated ? <Session15 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session152" element={userAuthenticated ? <Session152 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session16" element={userAuthenticated ? <Session16 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session162" element={userAuthenticated ? <Session162 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session171" element={userAuthenticated ? <Session171 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session142" element={userAuthenticated ? <Session142 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Factors21" element={userAuthenticated ? <Factors21 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Multiplynew" element={userAuthenticated ? < Multiplynew /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Twodigit" element={userAuthenticated ? <Twodigit /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Twodigitb" element={userAuthenticated ? <Twodigitb /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level2/Level5quiz" element={userAuthenticated ? <Level5quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level4quiz" element={userAuthenticated ? <Level4quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level3quiz" element={userAuthenticated ? <Level3quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level2quiz" element={userAuthenticated ? <Level2quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level1quiz" element={userAuthenticated ? <Level1quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Subtract1000" element={userAuthenticated ? <Subtract1000 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Subtract10000" element={userAuthenticated ? <Subtract10000 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Integer2" element={userAuthenticated ? <Integer2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Halfoften" element={userAuthenticated ? <Halfof /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session9" element={userAuthenticated ? <Session9 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session9part2" element={userAuthenticated ? <Session9part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11" element={userAuthenticated ? <Session11 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11part3" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Sessionpart3" element={userAuthenticated ? <Session11part3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Sessionpart4" element={userAuthenticated ? <Session11part4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session10" element={userAuthenticated ? <Session10 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11part2" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session8" element={userAuthenticated ? <Session8 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session7" element={userAuthenticated ? <Session7 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level2/Oneandhalf" element={userAuthenticated ? <Oneandhalf /> : <Authentication />} />



//           <Route path="/codomo/mentalmath/level4/Magicsquare" element={userAuthenticated ? <Magicsquare /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Proportion" element={userAuthenticated ? <Proportion /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Ratio" element={userAuthenticated ? <Ratio /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Scaling" element={userAuthenticated ? <Scaling /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Gessop" element={userAuthenticated ? <Gessop /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Nameriddle" element={userAuthenticated ? <Nameriddle /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level4/Sessions20v4" element={userAuthenticated ? <Sessions20v4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Start" element={userAuthenticated ? <Start /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level4/Start/Tc1" element={userAuthenticated ? <TC1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Start/Tc2" element={userAuthenticated ? <TC2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Tc3" element={userAuthenticated ? <TC3 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level4/Sessions19v1" element={userAuthenticated ? <Sessions19v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions19v2" element={userAuthenticated ? <Sessions19v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions19v3" element={userAuthenticated ? <Sessions19v3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v1" element={userAuthenticated ? <Sessions20v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v2" element={userAuthenticated ? <Sessions20v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v3" element={userAuthenticated ? <Sessions20v3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v5" element={userAuthenticated ? <Sessions20v5 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions21v1" element={userAuthenticated ? <Sessions21v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions21v2" element={userAuthenticated ? <Sessions21v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Activity1" element={userAuthenticated ? <Activity1 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Angle" element={userAuthenticated ? <Angle /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Time" element={userAuthenticated ? <Time /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement" element={userAuthenticated ? <Measurement /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/lfive/Measurement/level1" element={userAuthenticated ? <Level1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level2" element={userAuthenticated ? <Level2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level3" element={userAuthenticated ? <Level3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level4" element={userAuthenticated ? <Level4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level5" element={userAuthenticated ? <Level5 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival" element={userAuthenticated ? <Divisoncarnival /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival2" element={userAuthenticated ? <Divisoncarnival2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival2" element={userAuthenticated ? <Divisoncarnival2 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Meterandcm" element={userAuthenticated ? <Meterandcm /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Percentnew" element={userAuthenticated ? <Percentnew /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Weight" element={userAuthenticated ? <Weight /> : <Authentication />} />


//           <Route path="/codomo/mentalmath/level7/Binaryone" element={userAuthenticated ? <L7aone /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Binarytwo" element={userAuthenticated ? <L7atwo /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Binarythree" element={userAuthenticated ? <L7athree /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Security" element={userAuthenticated ? <L7afour /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Activity5" element={userAuthenticated ? <L7afive /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Activity6" element={userAuthenticated ? <L7asix /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/Bargraph2" element={userAuthenticated ? <Bargraph2 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Bargraph" element={userAuthenticated ? <Bargraph /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Datainterpretation" element={userAuthenticated ? <Datainterpretation /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Matchpiechart" element={userAuthenticated ? <MatchPieChart /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Mean" element={userAuthenticated ? <Mean /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Median" element={userAuthenticated ? <Median /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Mode" element={userAuthenticated ? <Mode /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Piechart" element={userAuthenticated ? <Piechart /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Puzzlepiechart" element={userAuthenticated ? <Puzzlepiechart /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Survey" element={userAuthenticated ? <Survey /> : <Authentication />} />


//           <Route path="/codomo/IntermediateAi/Activity1" element={userAuthenticated ? <Activity11 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity12" element={userAuthenticated ? <Activity12 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity13" element={userAuthenticated ? <Activity13 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity14" element={userAuthenticated ? <Activity14 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity15" element={userAuthenticated ? <Activity15 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity16" element={userAuthenticated ? <Activity16 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity17" element={userAuthenticated ? <Activity17 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity18" element={userAuthenticated ? <Activity18 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity19" element={userAuthenticated ? <Activity19 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity20" element={userAuthenticated ? <Activity20 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity21" element={userAuthenticated ? <Activity21 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity22" element={userAuthenticated ? <Activity22 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity23" element={userAuthenticated ? <Activity23 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity24" element={userAuthenticated ? <Activity24 /> : <Authentication />} />


//           <Route path="/codomo/Digitalbasics/Digital1" element={userAuthenticated ? <Digital1 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital2" element={userAuthenticated ? <Digital2 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital3" element={userAuthenticated ? <Digital3 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital4" element={userAuthenticated ? <Digital4 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital5" element={userAuthenticated ? <Digital5 /> : <Authentication />} />
//           {/* <Route path="/codomo/Digitalbasics/Digital5" element={userAuthenticated ? <Digital5 /> : <Authentication />} /> */}
//           <Route path="/codomo/Digitalbasics/Digital6" element={userAuthenticated ? <Digital6 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital7" element={userAuthenticated ? <Digital7 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital9" element={userAuthenticated ? <Digital9 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital10" element={userAuthenticated ? <Digital10 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital11" element={userAuthenticated ? <Digital11 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital12" element={userAuthenticated ? <Digital12 /> : <Authentication />} />


//           <Route path="/codomo/mentor/activities" element={userAuthenticated ? verifiedAsMentor ? <MentorActivities /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           {/* <Route path="/codomo/mentor/addbatch" element={userAuthenticated ? verifiedAsAdmin ? <AddBatch /> : <Navigate to="/codomo/home"/> : <Authentication />} /> */}
//           <Route path="/codomo/mentor/notification" element={userAuthenticated ? verifiedAsMentor ? <NotificationService /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/admiration" element={userAuthenticated ? verifiedAsMentor ? <Admiration /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/dashboard" element={userAuthenticated ? verifiedAsMentor ? <Dashboard /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           {/* <Route path="/codomo/mentor/addstudent" element={userAuthenticated ?verifiedAsAdmin ?<AddStudent /> : <Navigate to="/codomo/home"/> : <Authentication />} /> */}
//           <Route path="/codomo/mentor/addblog" element={userAuthenticated ? verifiedAsMentor ? <AddBlog /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/editbatch" element={userAuthenticated ? <EditBatch /> : <Authentication />} />

//           <Route path="/codomo/Gcse/TraceTable" element={userAuthenticated ? <TraceTable /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Flowchart" element={userAuthenticated ? <Flowchart /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Break" element={userAuthenticated ? <Break /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Binarytodecimal" element={userAuthenticated ? <Binarytodecimal /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Hexadecimal" element={userAuthenticated ? <Hexadecimal /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Decimaltobinary" element={userAuthenticated ? <Decimaltobinary /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Unicode" element={userAuthenticated ? <Unicode /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Pixelart" element={userAuthenticated ? <Pixelart /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Sound" element={userAuthenticated ? <Sound /> : <Authentication />} />

//           <Route path="/codomo/Gcse/Ascii" element={userAuthenticated ? <Ascii /> : <Authentication />} />



//           <Route path="/codomo/admin/createbatch" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           {/* <Route path="/codomo/admin/DemoDetails" element={userAuthenticated ? verifiedAsAdmin || verifiedAsBDE ? <DemoDetails /> : <Navigate to="/codomo/home" /> : <Authentication />} /> */}
//           {/* <Route path="/codomo/admin/DemoDetailsForm" element={userAuthenticated ? verifiedAsAdmin || verifiedAsBDE ? <DemoDetailsForm /> : <Navigate to="/codomo/home" /> : <Authentication />} /> */}

//           <Route path="/codomo/admin/addbatch" element={userAuthenticated ? verifiedAsAdmin ? <AddBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/addstudent" element={userAuthenticated ? verifiedAsAdmin ? <AddStudent /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/usermanagement" element={userAuthenticated ? verifiedAsAdmin ? <UserManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/createnewuser" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewUser /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/coursemanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/createnewcourse" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewCourse /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/activitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <ActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/downloadsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseDownloadsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/subactivitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <SubActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/mappingmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseMappingManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/assiginingcoursetomentor" element={userAuthenticated ? verifiedAsAdmin ? <AssiginingCourseToMentor /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/batchmanagement" element={userAuthenticated ? verifiedAsAdmin ? <BatchManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/assignBatch" element={<AssignBatchToTheMentor />} />
//           <Route path="/codomo/admin/accountsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <AccountsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />



//           <Route path="/" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/confirmemail" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <EmailConfirm />} />
//           <Route path="/signIn" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignIn />} />
//           <Route path="/signUp" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignUp />} />
//           <Route path="/videoCallActivity" element={<VideoCallActivity />} />
//           <Route path="/voiceCallActivity" element={<VoiceCallActivity />} />
//           <Route path="/chatScreen" element={<ChatScreen />} />
//           <Route path="/googleMeet" element={<GoogleMeet />} />




//           <Route path="*" element={<ErrorPage />} />
//         </Routes>
//       </AuthenticationState.Provider>
//     </div>
//   );
// }

// export default App;







































// import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";
// import React, { useEffect, useState, createContext, useContext } from 'react';
// import HomePage from "./Components/MainPage/HomePage";
// import SignIn from "./Components/MainPage/SignIn";
// import SignUp from "./Components/MainPage/SignUp"
// import Course from "./Components/MainPage/Course";
// import AboutOne from "./Components/MainPage/AboutOne"
// import EmailConfirm from "./Components/MainPage/EmailConfirm";
// import ContactUs from "./Components/MainPage/ContactUs"
// import Downloads from "./Components/MainPage/Downloads"
// import ErrorPage from "./Components/404ErrorPage";
// import MentorActivities from "./Components/MainPage/MentorActivities";
// import Authentication from "./Components/Authentication/Authentication";
// import AddBatch from "./Components/MainPage/AddBatch";
// import AddStudent from "./Components/MainPage/AddStudent"
// import Blog from "./Components/MainPage/Blog"
// import AddBlog from "./Components/MainPage/AddBlog";
// import EditBatch from "./Components/MainPage/EditBatch";
// import EditProfile from "./Components/MainPage/EditProfile";
// import UserManagement from "./Components/MainPage/UserManagement";
// import CreateNewUser from "./Components/MainPage/CreateNewUser";
// import CourseManagement from "./Components/MainPage/CourseManagement";
// import CreateNewCourse from "./Components/MainPage/CreateNewCourse";
// import ActivityManagement from "./Components/MainPage/ActivityManagement";
// import CourseDownloadsManagement from "./Components/MainPage/CourseDownloadsManagement";
// import SubActivityManagement from "./Components/MainPage/SubActivityManagement";
// import AdvancedCourse from "./Components/MainPage/AdvancedCourse";
// import CourseMappingManagement from "./Components/MainPage/CourseMappingManagement";
// import OneCompilerIframe from "./Components/MainPage/OneCompilerIframe";
// import Admiration from "./Components/MainPage/Admiration";
// import Popup from "./Components/MainPage/Popup";
// import NotificationService from "./Components/MainPage/NotificationService";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { AuthenticateUser, FetchHomePageDetails } from './api/aws-api';
// import { ConstructorEventPost, ConstructorEventGet } from './Event/event';
// import ActivityOne from "./Components/MainPage/ActivityOne";
// import ActivityOneOne from "./Components/MainPage/ActivityOneOne";
// import ActivityTwo from "./Components/MainPage/ActivityTwo";
// import ActivityTwoOne from "./Components/MainPage/ActivityTwoOne";
// import ActivityThree from "./Components/MainPage/ActivityThree";
// import ActivityFour from "./Components/MainPage/ActivityFour";
// import ActivityNine from "./Components/MainPage/ActivityNine";
// import StoryTellerActivity from "./Components/MainPage/StoryTellerActivity";
// import StoryTellerActivityOne from "./Components/MainPage/StoryTellerActivityOne";
// import ActivitySeven from "./Components/MainPage/ActivitySeven"
// import ActivityEight from "./Components/MainPage/ActivityEight"
// import ActivityFive from "./Components/MainPage/ActivityFive"
// import ActivitySix from "./Components/MainPage/ActivitySix"
// import ActivityTen from "./Components/MainPage/ActivityTen"
// import ActivityEleven from "./Components/MainPage/ActivityEleven"
// import AppLabSessionone from "./Components/MainPage/AppLabSessionone"
// import AppLabSessionthree from "./Components/MainPage/AppLabSessionthree"
// import Webusb from "./Components/MainPage/Webusb"
// import AppLabSessionfour from "./Components/MainPage/AppLabSessionfour"
// import AppLabSessionfive from "./Components/MainPage/AppLabSessionfive"
// import AppLabSessionsix from "./Components/MainPage/AppLabSessionsix"
// import AppLabSessionseven from "./Components/MainPage/AppLabSessionseven"
// import AppLabSessioneight from "./Components/MainPage/AppLabSessioneight"
// import AppLabSessionnine from "./Components/MainPage/AppLabSessionnine"
// import AppLabSessionten from "./Components/MainPage/AppLabSessionten"
// import AssiginingCourseToMentor from "./Components/MainPage/AssiginingCourseToMentor"
// import AppLabSessioneleven from "./Components/MainPage/AppLabSessioneleven"
// import VideoCallActivity from "./Components/MainPage/VideoCallActivity";
// import VoiceCallActivity from "./Components/MainPage/VoiceCallActivity";
// import ChatScreen from "./Components/MainPage/ChatScreen";
// import GoogleMeet from "./Components/MainPage/GoogleMeet";
// import BatchManagement from "./Components/MainPage/BatchManagement";
// import AssignBatchToTheMentor from "./Components/MainPage/AssignBatchToMentor";
// import AccountsManagement from "./Components/MainPage/AccountsManagement";
// import CreateNewBatch from "./Components/MainPage/CreateNewBatch";

// import Index1 from "./Components/MainPage/mentalmath/Index1";
// import Index2 from "./Components/MainPage/mentalmath/Index2";
// import Placevalue from "./Components/MainPage/mentalmath/Placevalue";
// import Placevalue2 from "./Components/MainPage/mentalmath/Placevalue2";
// import Placevalue3 from "./Components/MainPage/mentalmath/Placevalue3";
// import Placevalue4 from "./Components/MainPage/mentalmath/Placevalue4";
// import Divisible2 from "./Components/MainPage/mentalmath/Divisible2"
// import Multiple1 from "./Components/MainPage/mentalmath/Multiple"
// import Multiple2 from "./Components/MainPage/mentalmath/Multiple2"
// import Multiple3 from "./Components/MainPage/mentalmath/multiple3"
// import Newactivityone from "./Components/MainPage/mentalmath/Newactivityone"
// import Newactivitytwo from "./Components/MainPage/mentalmath/Newactivitytwo"
// import Newactivitythree from "./Components/MainPage/mentalmath/Newactivitythree"

// import Halving from "./Components/MainPage/mentalmath/Halving"
// import Backtrack1 from "./Components/MainPage/mentalmath/Backtrack1";
// import Backtrack2 from "./Components/MainPage/mentalmath/Backtrack2";
// import Backtrack3 from "./Components/MainPage/mentalmath/Backtrack3";
// import Compositesmash from "./Components/MainPage/mentalmath/Compositesmash";
// import Prime from "./Components/MainPage/mentalmath/Prime";
// import Angles2 from "./Components/MainPage/mentalmath/Angles2";
// import Shapetrain from "./Components/MainPage/mentalmath/Shapetrain";
// import Shapes from "./Components/MainPage/mentalmath/Shapes";
// import Task2 from "./Components/MainPage/mentalmath/Task2";
// import Task3 from "./Components/MainPage/mentalmath/Task3";

// import Estimation2 from "./Components/MainPage/mentalmath/Estimation2";
// import Estimation1 from "./Components/MainPage/mentalmath/Estimation1";
// import Estimation3 from "./Components/MainPage/mentalmath/Estimation3";
// import Complement1 from "./Components/MainPage/mentalmath/Complement1";
// import Complement2 from "./Components/MainPage/mentalmath/Complement2";
// import Count from "./Components/MainPage/mentalmath/Count";
// import Dh from "./Components/MainPage/mentalmath/Dh";

// import Divisible3 from "./Components/MainPage/mentalmath/Divisible3";
// import Divisible from "./Components/MainPage/mentalmath/Divisible";
// import Indexl2 from "./Components/MainPage/mentalmath/Indexl2";
// import Indexl1 from "./Components/MainPage/mentalmath/Indexl1";
// import Lr1 from "./Components/MainPage/mentalmath/Lr1";
// import Lr2 from "./Components/MainPage/mentalmath/Lr2";
// import Lr3 from "./Components/MainPage/mentalmath/Lr3";
// import Rounding1 from "./Components/MainPage/mentalmath/Rounding1";
// import Rounding2 from "./Components/MainPage/mentalmath/Rounding2";

// import Factors from "./Components/MainPage/mentalmath/Factors";
// import Factors2 from "./Components/MainPage/mentalmath/Factors2";
// import Grouping1 from "./Components/MainPage/mentalmath/Grouping1";
// import Session141 from './Components/MainPage/mentalmath/lthree/Session141';
// import Session142 from './Components/MainPage/mentalmath/lthree/Session142';
// import Session15 from './Components/MainPage/mentalmath/lthree/Session15';
// import Session152 from './Components/MainPage/mentalmath/lthree/Session152';
// import Factors21 from './Components/MainPage/mentalmath/lthree/Factors21'

// import Session16 from './Components/MainPage/mentalmath/lthree/Session16'
// import Session162 from './Components/MainPage/mentalmath/lthree/Session162'
// import Session172 from './Components/MainPage/mentalmath/lthree/Session172'
// import Session171 from './Components/MainPage/mentalmath/lthree/Session171';
// import Halfof from "./Components/MainPage/mentalmath/level2/Halfsofhtml"
// import Session9 from "./Components/MainPage/mentalmath/level2/Session9"
// import Session9part2 from "./Components/MainPage/mentalmath/level2/Session9part2"
// import Session10 from "./Components/MainPage/mentalmath/level2/Sesssion10"
// import Session11 from "./Components/MainPage/mentalmath/level2/Session11"
// import Session11part2 from "./Components/MainPage/mentalmath/level2/Session11part2"
// import Session11part3 from "./Components/MainPage/mentalmath/level2/Session11part3"
// import Session11part4 from "./Components/MainPage/mentalmath/level2/Session11part4"
// import Session7 from "./Components/MainPage/mentalmath/level2/Sessions7"
// import Session8 from "./Components/MainPage/mentalmath/level2/Sessions8v2"
// import Integer2 from "./Components/MainPage/mentalmath/level2/Interger2"
// import Subtract1000 from "./Components/MainPage/mentalmath/level2/Subtract1000"
// import Subtract10000 from "./Components/MainPage/mentalmath/level2/Subtract10000"
// import Oneandhalf from "./Components/MainPage/mentalmath/level2/Oneandhalf"
// import Level1quiz from "./Components/MainPage/mentalmath/level2/Level1quiz"
// import Level2quiz from "./Components/MainPage/mentalmath/level2/Level2quiz"
// import Level3quiz from "./Components/MainPage/mentalmath/level2/Level3quiz"
// import Level4quiz from "./Components/MainPage/mentalmath/level2/Level4quiz"
// import Level5quiz from "./Components/MainPage/mentalmath/level2/Level5quiz"
// import Multiplynew from "./Components/MainPage/mentalmath/level2/Newactivitymultiply"
// import Twodigit from "./Components/MainPage/mentalmath/level2/Twodigit"
// import Twodigitb from "./Components/MainPage/mentalmath/level2/Twodigitb"

// import Sessions20v4 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
// import Sessions19v1 from "./Components/MainPage/mentalmath/level4/Sessions19v1"
// import Sessions19v2 from "./Components/MainPage/mentalmath/level4/Sessions19v2"
// import Sessions19v3 from "./Components/MainPage/mentalmath/level4/Sessions19v3"
// import Sessions20v1 from "./Components/MainPage/mentalmath/level4/Sessions20v1"
// import Sessions20v2 from "./Components/MainPage/mentalmath/level4/Sessions20v2"
// import Sessions20v3 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
// import Sessions20v5 from "./Components/MainPage/mentalmath/level4/Sessions20v5"
// import Sessions21v1 from "./Components/MainPage/mentalmath/level4/Sessions21v1"
// import Sessions21v2 from "./Components/MainPage/mentalmath/level4/Sessions21v2"
// import Magicsquare from "./Components/MainPage/mentalmath/level4/Magicsquare"
// import Proportion from "./Components/MainPage/mentalmath/level4/Proportion"
// import Scaling from "./Components/MainPage/mentalmath/level4/Scaling"
// import Ratio from "./Components/MainPage/mentalmath/level4/Ratio"
// import Gessop from "./Components/MainPage/mentalmath/level4/Gessop"
// import Nameriddle from './Components/MainPage/mentalmath/level4/Nameriddle'
// import TC1 from "./Components/MainPage/mentalmath/level4/Tc1"
// import TC2 from "./Components/MainPage/mentalmath/level4/Tc2"
// import TC3 from "./Components/MainPage/mentalmath/level4/Tc3"
// import Start from "./Components/MainPage/mentalmath/level4/start1"

// import Activity1 from "./Components/MainPage/mentalmath/lfive/Activity1";
// import Activity2 from "./Components/MainPage/mentalmath/lfive/Activity2";
// import Angle from "./Components/MainPage/mentalmath/lfive/Angle";
// import Measurement from "./Components/MainPage/mentalmath/lfive/Measurement";
// import Level1 from "./Components/MainPage/mentalmath/lfive/Level1";
// import Level2 from "./Components/MainPage/mentalmath/lfive/Level2";
// import Level3 from "./Components/MainPage/mentalmath/lfive/Level3";
// import Level4 from "./Components/MainPage/mentalmath/lfive/Level4";
// import Level5 from "./Components/MainPage/mentalmath/lfive/Level5";
// import Time from "./Components/MainPage/mentalmath/lfive/Time";
// import Divisoncarnival from "./Components/MainPage/mentalmath/lfive/Divisoncarnival";
// import Divisoncarnival2 from "./Components/MainPage/mentalmath/lfive/Divisoncarnival2";
// import Meterandcm from "./Components/MainPage/mentalmath/lfive/Meterandcm";
// import Percentnew from "./Components/MainPage/mentalmath/lfive/percentnew";
// import Weight from "./Components/MainPage/mentalmath/lfive/Weight";

// import Bargraph2 from "./Components/MainPage/mentalmath/level6/Bargraph2"
// import Bargraph from "./Components/MainPage/mentalmath/level6/Bargraph"
// import Datainterpretation from "./Components/MainPage/mentalmath/level6/Datainterpretation"
// import MatchPieChart from "./Components/MainPage/mentalmath/level6/Matchpiechart";
// import Mean from "./Components/MainPage/mentalmath/level6/Mean"
// import Median from "./Components/MainPage/mentalmath/level6/Median"
// import Mode from "./Components/MainPage/mentalmath/level6/Mode"
// import Piechart from "./Components/MainPage/mentalmath/level6/Piechart"
// import Puzzlepiechart from "./Components/MainPage/mentalmath/level6/Puzzlepiechart"
// import Survey from "./Components/MainPage/mentalmath/level6/Survey"
// import L7aone from "./Components/MainPage/mentalmath/level7/Activityone"
// import L7atwo from "./Components/MainPage/mentalmath/level7/Activitytwo"
// import L7athree from "./Components/MainPage/mentalmath/level7/Activitythree"
// import L7afour from "./Components/MainPage/mentalmath/level7/Activity4"
// import L7afive from "./Components/MainPage/mentalmath/level7/Activity5"
// import L7asix from "./Components/MainPage/mentalmath/level7/Activity6"

// import Activity11 from "./Components/MainPage/IntermediateAi/Activity1"
// import Activity12 from "./Components/MainPage/IntermediateAi/Activity2"
// import Activity13 from "./Components/MainPage/IntermediateAi/Activity3"
// import Activity14 from "./Components/MainPage/IntermediateAi/Activity4"
// import Activity15 from "./Components/MainPage/IntermediateAi/Activity5"
// import Activity16 from "./Components/MainPage/IntermediateAi/Activity6"
// import Activity17 from "./Components/MainPage/IntermediateAi/Activity7"
// import Activity18 from "./Components/MainPage/IntermediateAi/Activity8"
// import Activity19 from "./Components/MainPage/IntermediateAi/Activity9"
// import Activity20 from "./Components/MainPage/IntermediateAi/Activity10"
// import Activity21 from "./Components/MainPage/IntermediateAi/Activity11"
// import Activity22 from "./Components/MainPage/IntermediateAi/Activity12"
// import Activity23 from "./Components/MainPage/IntermediateAi/Activity13"
// import Activity24 from "./Components/MainPage/IntermediateAi/Activity14"

// import Digital1 from "./Components/MainPage/Digitalbasics/Digital1"
// import Digital2 from "./Components/MainPage/Digitalbasics/Digital2"
// import Digital3 from "./Components/MainPage/Digitalbasics/Digital3"
// import Digital4 from "./Components/MainPage/Digitalbasics/Digital4"
// import Digital5 from "./Components/MainPage/Digitalbasics/Digital5"
// import Digital6 from "./Components/MainPage/Digitalbasics/Digital6"
// import Digital7 from "./Components/MainPage/Digitalbasics/Digital7"
// import Digital9 from "./Components/MainPage/Digitalbasics/Digital9"
// import Digital10 from "./Components/MainPage/Digitalbasics/Digital10"
// import Digital11 from "./Components/MainPage/Digitalbasics/Digital11"
// import Digital12 from "./Components/MainPage/Digitalbasics/Digital12"

// import Count2s from "./Components/MainPage/mentalmath/Count2s"
// import Count10s from "./Components/MainPage/mentalmath/Count10s"
// import Count100s from "./Components/MainPage/mentalmath/Count100s"
// import Dashboard from "./Components/MainPage/Dashboard";

// import Break from "./Components/MainPage/Gcs/Break";
// import Flowchart from "./Components/MainPage/Gcs/Flowchart";
// import TraceTable from "./Components/MainPage/Gcs/TraceTable";
// import Binarytodecimal from "./Components/MainPage/Gcs/Binarytodecimal";
// import Decimaltobinary from "./Components/MainPage/Gcs/Decimaltobinary";
// import Hexadecimal from "./Components/MainPage/Gcs/Hexadecimal";
// import Unicode from "./Components/MainPage/Gcs/Unicode";
// import Pixelart from "./Components/MainPage/Gcs/Pixelart";
// import Ascii from "./Components/MainPage/Gcs/Ascii";
// import Sound from "./Components/MainPage/Gcs/Sound";

// export const AuthenticationState = createContext();

// function App() {
//   const [userAuthenticated, setuserAuthenticated] = useState(false)
//   const [verifiedAsMentor, setVerifiedAsMentor] = useState(false)
//   const [verifiedAsAdmin, setVerifiedAsAdmin] = useState(false)
//   const [verifiedAsBDE, setVerifiedAsBDE] = useState(false)
//   const location = useLocation();
//   const navigate = useNavigate()

//   // Re-checks session validity whenever the route changes (and once on
//   // load). If a valid, non-expired authToken exists but React state hasn't
//   // confirmed it yet, this triggers CheckStatus to verify it against the
//   // backend and flip userAuthenticated accordingly.
//   useEffect(() => {
//     if (location.pathname !== "/signUp") {
//       const lastLoginTime = localStorage.getItem('lastLoginTime')
//       const authToken = localStorage.getItem('authToken')
//       if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && !userAuthenticated) {
//         CheckStatus(authToken)
//       }
//       else if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && userAuthenticated) { }
//       else if (authToken && (Date.now() - lastLoginTime) > 24 * 60 * 120 * 1000 && userAuthenticated) {
//         setuserAuthenticated(false)
//         navigate("/signIn")
//       }
//       else {
//         setuserAuthenticated(false)
//       }
//     }
//   }, [location.pathname, userAuthenticated]
//   );

//   // Verifies a stored authToken against the backend, with a timeout so a
//   // hung request can't leave the UI stuck. On success, flips
//   // userAuthenticated (routes below react to that automatically). On
//   // failure/timeout, clears the stale session and sends the user to sign in.
//   const CheckStatus = async (authToken) => {
//     const storedData = localStorage.getItem('UserKey');

//     if (!storedData || storedData === "undefined" || storedData === "null") {
//       setuserAuthenticated(false);
//       navigate("/signIn");
//       return;
//     }

//     try {
//       const params = JSON.parse(storedData);
//       fetchdata(params);
//       params["authToken"] = authToken;

//       const timeoutPromise = new Promise((_, reject) =>
//         setTimeout(() => reject(new Error('timeout')), 10000)
//       );

//       const responsedata = await Promise.race([
//         ConstructorEventPost(AuthenticateUser, params),
//         timeoutPromise
//       ]);

//       if (responsedata === "authentication_success") {
//         setuserAuthenticated(true);
//         if (location.pathname !== "/codomo/home") {
//           navigate("/codomo/home");
//         }
//       } else {
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('lastLoginTime');
//         localStorage.removeItem('UserKey');
//         setuserAuthenticated(false);
//         navigate("/signIn");
//       }
//     } catch (e) {
//       console.warn("CheckStatus failed:", e);
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('lastLoginTime');
//       localStorage.removeItem('UserKey');
//       setuserAuthenticated(false);
//       navigate("/signIn");
//     }
//   };

//   const fetchdata = async (params) => {
//     const responsedata = await ConstructorEventGet(FetchHomePageDetails, params)
//     sessionStorage.setItem('UserData', JSON.stringify(responsedata[0]))
//     checkUserType(responsedata[0])
//   }

//   function checkUserType(data) {
//     const userType = data && data.user_type
//     if (userType === "mentor") {
//       setVerifiedAsMentor(true)
//     }
//     else if (userType === "admin") {
//       setVerifiedAsAdmin(true)
//     } else if (userType === "BDE") {
//       setVerifiedAsBDE(true)
//     }
//   }

//   return (
//     <div className="font-gilroy font-medium text-gray text-lg leading-[27px]">
//       <ToastContainer />
//       <AuthenticationState.Provider value={{
//         userAuthenticated,
//         setuserAuthenticated: (value) => {
//           setuserAuthenticated(value);
//           if (value) {
//             navigate("/codomo/home");
//           }
//         },
//         verifiedAsMentor,
//         setVerifiedAsMentor,
//         verifiedAsAdmin,
//         setVerifiedAsAdmin
//       }}>
//         <Routes>
//           <Route path="/codomo/home" element={userAuthenticated ? <HomePage /> : <Authentication />} />
//           <Route path="/codomo/landing" element={userAuthenticated ? <AboutOne /> : <Authentication />} />
//           <Route path="/codomo/course" element={userAuthenticated ? <Course /> : <Authentication />} />
//           <Route path="/codomo/contactus" element={userAuthenticated ? <ContactUs /> : <Authentication />} />
//           <Route path="/codomo/course/downloads" element={userAuthenticated ? <Downloads /> : <Authentication />} />
//           <Route path="/codomo/blog" element={userAuthenticated ? <Blog /> : <Authentication />} />
//           <Route path="/codomo/editprofile" element={userAuthenticated ? <EditProfile /> : <Authentication />} />
//           <Route path="/codomo/codeeditor" element={userAuthenticated ? <AdvancedCourse /> : <Authentication />} />
//           <Route path="/codomo/popup" element={userAuthenticated ? <Popup /> : <Authentication />} />
//           <Route path="/codomo/ActivityOne" element={userAuthenticated ? <ActivityOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityOneOne" element={userAuthenticated ? <ActivityOneOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityTwo" element={userAuthenticated ? <ActivityTwo /> : <Authentication />} />
//           <Route path="/codomo/ActivityTwoOne" element={userAuthenticated ? <ActivityTwoOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityThree" element={userAuthenticated ? <ActivityThree /> : <Authentication />} />
//           <Route path="/codomo/StoryTellerActivity" element={userAuthenticated ? <StoryTellerActivity /> : <Authentication />} />
//           <Route path="/codomo/StoryTellerActivityOne" element={userAuthenticated ? <StoryTellerActivityOne /> : <Authentication />} />
//           <Route path="/codomo/ActivitySeven" element={userAuthenticated ? <ActivitySeven /> : <Authentication />} />
//           <Route path="/codomo/ActivityEight" element={userAuthenticated ? <ActivityEight /> : <Authentication />} />
//           <Route path="/codomo/ActivityNine" element={userAuthenticated ? <ActivityNine /> : <Authentication />} />
//           <Route path="/codomo/ActivityFour" element={userAuthenticated ? <ActivityFour /> : <Authentication />} />
//           <Route path="/codomo/ActivityFive" element={userAuthenticated ? <ActivityFive /> : <Authentication />} />
//           <Route path="/codomo/ActivitySix" element={userAuthenticated ? <ActivitySix /> : <Authentication />} />
//           <Route path="/codomo/ActivityTen" element={userAuthenticated ? <ActivityTen /> : <Authentication />} />
//           <Route path="/codomo/ActivityEleven" element={userAuthenticated ? <ActivityEleven /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionone" element={userAuthenticated ? <AppLabSessionone /> : <Authentication />} />
//           <Route path="/codomo/Webusb" element={userAuthenticated ? <Webusb /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionthree" element={userAuthenticated ? <AppLabSessionthree /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionfour" element={userAuthenticated ? <AppLabSessionfour /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionfive" element={userAuthenticated ? <AppLabSessionfive /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionsix" element={userAuthenticated ? <AppLabSessionsix /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionseven" element={userAuthenticated ? <AppLabSessionseven /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessioneight" element={userAuthenticated ? <AppLabSessioneight /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionnine" element={userAuthenticated ? <AppLabSessionnine /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionten" element={userAuthenticated ? <AppLabSessionten /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessioneleven" element={userAuthenticated ? <AppLabSessioneleven /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Index1" element={userAuthenticated ? <Index1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Index2" element={userAuthenticated ? <Index2 /> : <Authentication />} />
//           <Route path="/codomo/onecompiler" element={userAuthenticated ? <OneCompilerIframe /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack1" element={userAuthenticated ? <Backtrack1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack2" element={userAuthenticated ? <Backtrack2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack3" element={userAuthenticated ? <Backtrack3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation2" element={userAuthenticated ? <Estimation2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation1" element={userAuthenticated ? <Estimation1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation3" element={userAuthenticated ? <Estimation3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Complement1" element={userAuthenticated ? <Complement1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Complement2" element={userAuthenticated ? <Complement2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Dh" element={userAuthenticated ? <Dh /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count" element={userAuthenticated ? <Count /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count2s" element={userAuthenticated ? <Count2s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count10s" element={userAuthenticated ? <Count10s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count100s" element={userAuthenticated ? <Count100s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divisible3" element={userAuthenticated ? <Divisible3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divisible" element={userAuthenticated ? <Divisible /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Factors" element={userAuthenticated ? <Factors /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Factors2" element={userAuthenticated ? <Factors2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Grouping1" element={userAuthenticated ? <Grouping1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Rounding" element={userAuthenticated ? <Rounding1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Rounding2" element={userAuthenticated ? <Rounding2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Angles2" element={userAuthenticated ? <Angles2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Shapetrain" element={userAuthenticated ? <Shapetrain /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Shapes" element={userAuthenticated ? <Shapes /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Task2" element={userAuthenticated ? <Task2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Task3" element={userAuthenticated ? <Task3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Newactivityone" element={userAuthenticated ? <Newactivityone /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Newactivitytwo" element={userAuthenticated ? <Newactivitytwo /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Newactivitythree" element={userAuthenticated ? <Newactivitythree /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Indexl1" element={userAuthenticated ? <Indexl1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Indexl2" element={userAuthenticated ? <Indexl2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr1" element={userAuthenticated ? <Lr1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr2" element={userAuthenticated ? <Lr2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr3" element={userAuthenticated ? <Lr3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Halving" element={userAuthenticated ? <Halving /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Placevalue" element={userAuthenticated ? <Placevalue /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Placevalue2" element={userAuthenticated ? <Placevalue2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/placevalue3" element={userAuthenticated ? <Placevalue3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/placevalue4" element={userAuthenticated ? <Placevalue4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divible2" element={userAuthenticated ? <Divisible2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple1" element={userAuthenticated ? <Multiple1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple2" element={userAuthenticated ? <Multiple2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple3" element={userAuthenticated ? <Multiple3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Compositesmash" element={userAuthenticated ? <Compositesmash /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Prime" element={userAuthenticated ? <Prime /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session172" element={userAuthenticated ? <Session172 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session141" element={userAuthenticated ? <Session141 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session15" element={userAuthenticated ? <Session15 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session152" element={userAuthenticated ? <Session152 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session16" element={userAuthenticated ? <Session16 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session162" element={userAuthenticated ? <Session162 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session171" element={userAuthenticated ? <Session171 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session142" element={userAuthenticated ? <Session142 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Factors21" element={userAuthenticated ? <Factors21 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Multiplynew" element={userAuthenticated ? <Multiplynew /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Twodigit" element={userAuthenticated ? <Twodigit /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Twodigitb" element={userAuthenticated ? <Twodigitb /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level5quiz" element={userAuthenticated ? <Level5quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level4quiz" element={userAuthenticated ? <Level4quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level3quiz" element={userAuthenticated ? <Level3quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level2quiz" element={userAuthenticated ? <Level2quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level1quiz" element={userAuthenticated ? <Level1quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Subtract1000" element={userAuthenticated ? <Subtract1000 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Subtract10000" element={userAuthenticated ? <Subtract10000 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Integer2" element={userAuthenticated ? <Integer2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Halfoften" element={userAuthenticated ? <Halfof /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session9" element={userAuthenticated ? <Session9 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session9part2" element={userAuthenticated ? <Session9part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11" element={userAuthenticated ? <Session11 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11part3" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Sessionpart3" element={userAuthenticated ? <Session11part3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Sessionpart4" element={userAuthenticated ? <Session11part4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session10" element={userAuthenticated ? <Session10 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11part2" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session8" element={userAuthenticated ? <Session8 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session7" element={userAuthenticated ? <Session7 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Oneandhalf" element={userAuthenticated ? <Oneandhalf /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Magicsquare" element={userAuthenticated ? <Magicsquare /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Proportion" element={userAuthenticated ? <Proportion /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Ratio" element={userAuthenticated ? <Ratio /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Scaling" element={userAuthenticated ? <Scaling /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Gessop" element={userAuthenticated ? <Gessop /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Nameriddle" element={userAuthenticated ? <Nameriddle /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v4" element={userAuthenticated ? <Sessions20v4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Start" element={userAuthenticated ? <Start /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Start/Tc1" element={userAuthenticated ? <TC1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Start/Tc2" element={userAuthenticated ? <TC2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Tc3" element={userAuthenticated ? <TC3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions19v1" element={userAuthenticated ? <Sessions19v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions19v2" element={userAuthenticated ? <Sessions19v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions19v3" element={userAuthenticated ? <Sessions19v3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v1" element={userAuthenticated ? <Sessions20v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v2" element={userAuthenticated ? <Sessions20v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v3" element={userAuthenticated ? <Sessions20v3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v5" element={userAuthenticated ? <Sessions20v5 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions21v1" element={userAuthenticated ? <Sessions21v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions21v2" element={userAuthenticated ? <Sessions21v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Activity1" element={userAuthenticated ? <Activity1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Angle" element={userAuthenticated ? <Angle /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Time" element={userAuthenticated ? <Time /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement" element={userAuthenticated ? <Measurement /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level1" element={userAuthenticated ? <Level1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level2" element={userAuthenticated ? <Level2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level3" element={userAuthenticated ? <Level3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level4" element={userAuthenticated ? <Level4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level5" element={userAuthenticated ? <Level5 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival" element={userAuthenticated ? <Divisoncarnival /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival2" element={userAuthenticated ? <Divisoncarnival2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Meterandcm" element={userAuthenticated ? <Meterandcm /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Percentnew" element={userAuthenticated ? <Percentnew /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Weight" element={userAuthenticated ? <Weight /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Binaryone" element={userAuthenticated ? <L7aone /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Binarytwo" element={userAuthenticated ? <L7atwo /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Binarythree" element={userAuthenticated ? <L7athree /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Security" element={userAuthenticated ? <L7afour /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Activity5" element={userAuthenticated ? <L7afive /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Activity6" element={userAuthenticated ? <L7asix /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Bargraph2" element={userAuthenticated ? <Bargraph2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Bargraph" element={userAuthenticated ? <Bargraph /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Datainterpretation" element={userAuthenticated ? <Datainterpretation /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Matchpiechart" element={userAuthenticated ? <MatchPieChart /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Mean" element={userAuthenticated ? <Mean /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Median" element={userAuthenticated ? <Median /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Mode" element={userAuthenticated ? <Mode /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Piechart" element={userAuthenticated ? <Piechart /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Puzzlepiechart" element={userAuthenticated ? <Puzzlepiechart /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Survey" element={userAuthenticated ? <Survey /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity1" element={userAuthenticated ? <Activity11 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity12" element={userAuthenticated ? <Activity12 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity13" element={userAuthenticated ? <Activity13 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity14" element={userAuthenticated ? <Activity14 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity15" element={userAuthenticated ? <Activity15 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity16" element={userAuthenticated ? <Activity16 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity17" element={userAuthenticated ? <Activity17 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity18" element={userAuthenticated ? <Activity18 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity19" element={userAuthenticated ? <Activity19 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity20" element={userAuthenticated ? <Activity20 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity21" element={userAuthenticated ? <Activity21 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity22" element={userAuthenticated ? <Activity22 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity23" element={userAuthenticated ? <Activity23 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity24" element={userAuthenticated ? <Activity24 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital1" element={userAuthenticated ? <Digital1 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital2" element={userAuthenticated ? <Digital2 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital3" element={userAuthenticated ? <Digital3 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital4" element={userAuthenticated ? <Digital4 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital5" element={userAuthenticated ? <Digital5 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital6" element={userAuthenticated ? <Digital6 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital7" element={userAuthenticated ? <Digital7 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital9" element={userAuthenticated ? <Digital9 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital10" element={userAuthenticated ? <Digital10 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital11" element={userAuthenticated ? <Digital11 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital12" element={userAuthenticated ? <Digital12 /> : <Authentication />} />
//           <Route path="/codomo/mentor/activities" element={userAuthenticated ? verifiedAsMentor ? <MentorActivities /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/notification" element={userAuthenticated ? verifiedAsMentor ? <NotificationService /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/admiration" element={userAuthenticated ? verifiedAsMentor ? <Admiration /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/dashboard" element={userAuthenticated ? verifiedAsMentor ? <Dashboard /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/addblog" element={userAuthenticated ? verifiedAsMentor ? <AddBlog /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/editbatch" element={userAuthenticated ? <EditBatch /> : <Authentication />} />
//           <Route path="/codomo/Gcse/TraceTable" element={userAuthenticated ? <TraceTable /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Flowchart" element={userAuthenticated ? <Flowchart /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Break" element={userAuthenticated ? <Break /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Binarytodecimal" element={userAuthenticated ? <Binarytodecimal /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Hexadecimal" element={userAuthenticated ? <Hexadecimal /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Decimaltobinary" element={userAuthenticated ? <Decimaltobinary /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Unicode" element={userAuthenticated ? <Unicode /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Pixelart" element={userAuthenticated ? <Pixelart /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Sound" element={userAuthenticated ? <Sound /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Ascii" element={userAuthenticated ? <Ascii /> : <Authentication />} />
//           <Route path="/codomo/admin/createbatch" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/addbatch" element={userAuthenticated ? verifiedAsAdmin ? <AddBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/addstudent" element={userAuthenticated ? verifiedAsAdmin ? <AddStudent /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/usermanagement" element={userAuthenticated ? verifiedAsAdmin ? <UserManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/createnewuser" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewUser /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/coursemanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/createnewcourse" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewCourse /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/activitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <ActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/downloadsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseDownloadsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/subactivitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <SubActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/mappingmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseMappingManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/assiginingcoursetomentor" element={userAuthenticated ? verifiedAsAdmin ? <AssiginingCourseToMentor /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/batchmanagement" element={userAuthenticated ? verifiedAsAdmin ? <BatchManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/assignBatch" element={<AssignBatchToTheMentor />} />
//           <Route path="/codomo/admin/accountsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <AccountsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/confirmemail" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <EmailConfirm />} />
//           <Route path="/signIn" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignIn />} />
//           <Route path="/signUp" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignUp />} />
//           <Route path="/videoCallActivity" element={<VideoCallActivity />} />
//           <Route path="/voiceCallActivity" element={<VoiceCallActivity />} />
//           <Route path="/chatScreen" element={<ChatScreen />} />
//           <Route path="/googleMeet" element={<GoogleMeet />} />
//           <Route path="*" element={<ErrorPage />} />
//         </Routes>
//       </AuthenticationState.Provider>
//     </div>
//   );
// }

// export default App;























// import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";
// import React, { useEffect, useState, createContext, useContext } from 'react';
// import HomePage from "./Components/MainPage/HomePage";
// import SignIn from "./Components/MainPage/SignIn";
// import SignUp from "./Components/MainPage/SignUp"
// import Course from "./Components/MainPage/Course";
// import AboutOne from "./Components/MainPage/AboutOne"
// import EmailConfirm from "./Components/MainPage/EmailConfirm";
// import ContactUs from "./Components/MainPage/ContactUs"
// import Downloads from "./Components/MainPage/Downloads"
// import ErrorPage from "./Components/404ErrorPage";
// import MentorActivities from "./Components/MainPage/MentorActivities";
// import Authentication from "./Components/Authentication/Authentication";
// import AddBatch from "./Components/MainPage/AddBatch";
// import AddStudent from "./Components/MainPage/AddStudent"
// import Blog from "./Components/MainPage/Blog"
// import AddBlog from "./Components/MainPage/AddBlog";
// import EditBatch from "./Components/MainPage/EditBatch";
// import EditProfile from "./Components/MainPage/EditProfile";
// import UserManagement from "./Components/MainPage/UserManagement";
// import CreateNewUser from "./Components/MainPage/CreateNewUser";
// import CourseManagement from "./Components/MainPage/CourseManagement";
// import CreateNewCourse from "./Components/MainPage/CreateNewCourse";
// import ActivityManagement from "./Components/MainPage/ActivityManagement";
// import CourseDownloadsManagement from "./Components/MainPage/CourseDownloadsManagement";
// import SubActivityManagement from "./Components/MainPage/SubActivityManagement";
// import AdvancedCourse from "./Components/MainPage/AdvancedCourse";
// import CourseMappingManagement from "./Components/MainPage/CourseMappingManagement";
// import OneCompilerIframe from "./Components/MainPage/OneCompilerIframe";
// import Admiration from "./Components/MainPage/Admiration";
// import Popup from "./Components/MainPage/Popup";
// import NotificationService from "./Components/MainPage/NotificationService";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { AuthenticateUser, FetchHomePageDetails } from './api/aws-api';
// import { ConstructorEventPost, ConstructorEventGet } from './Event/event';
// import ActivityOne from "./Components/MainPage/ActivityOne";
// import ActivityOneOne from "./Components/MainPage/ActivityOneOne";
// import ActivityTwo from "./Components/MainPage/ActivityTwo";
// import ActivityTwoOne from "./Components/MainPage/ActivityTwoOne";
// import ActivityThree from "./Components/MainPage/ActivityThree";
// import ActivityFour from "./Components/MainPage/ActivityFour";
// import ActivityNine from "./Components/MainPage/ActivityNine";
// import StoryTellerActivity from "./Components/MainPage/StoryTellerActivity";
// import StoryTellerActivityOne from "./Components/MainPage/StoryTellerActivityOne";
// import ActivitySeven from "./Components/MainPage/ActivitySeven"
// import ActivityEight from "./Components/MainPage/ActivityEight"
// import ActivityFive from "./Components/MainPage/ActivityFive"
// import ActivitySix from "./Components/MainPage/ActivitySix"
// import ActivityTen from "./Components/MainPage/ActivityTen"
// import ActivityEleven from "./Components/MainPage/ActivityEleven"
// import AppLabSessionone from "./Components/MainPage/AppLabSessionone"
// import AppLabSessionthree from "./Components/MainPage/AppLabSessionthree"
// import Webusb from "./Components/MainPage/Webusb"
// import AppLabSessionfour from "./Components/MainPage/AppLabSessionfour"
// import AppLabSessionfive from "./Components/MainPage/AppLabSessionfive"
// import AppLabSessionsix from "./Components/MainPage/AppLabSessionsix"
// import AppLabSessionseven from "./Components/MainPage/AppLabSessionseven"
// import AppLabSessioneight from "./Components/MainPage/AppLabSessioneight"
// import AppLabSessionnine from "./Components/MainPage/AppLabSessionnine"
// import AppLabSessionten from "./Components/MainPage/AppLabSessionten"
// import AssiginingCourseToMentor from "./Components/MainPage/AssiginingCourseToMentor"
// import AppLabSessioneleven from "./Components/MainPage/AppLabSessioneleven"
// import VideoCallActivity from "./Components/MainPage/VideoCallActivity";
// import VoiceCallActivity from "./Components/MainPage/VoiceCallActivity";
// import ChatScreen from "./Components/MainPage/ChatScreen";
// import GoogleMeet from "./Components/MainPage/GoogleMeet";
// import BatchManagement from "./Components/MainPage/BatchManagement";
// import AssignBatchToTheMentor from "./Components/MainPage/AssignBatchToMentor";
// import AccountsManagement from "./Components/MainPage/AccountsManagement";
// import CreateNewBatch from "./Components/MainPage/CreateNewBatch";

// // ------------------------------------------------------------------------------------------

// import Index1 from "./Components/MainPage/mentalmath/Index1";
// import Index2 from "./Components/MainPage/mentalmath/Index2";
// import Placevalue from "./Components/MainPage/mentalmath/Placevalue";
// import Placevalue2 from "./Components/MainPage/mentalmath/Placevalue2";
// import Placevalue3 from "./Components/MainPage/mentalmath/Placevalue3";
// import Placevalue4 from "./Components/MainPage/mentalmath/Placevalue4";
// import Divisible2 from "./Components/MainPage/mentalmath/Divisible2"
// import Multiple1 from "./Components/MainPage/mentalmath/Multiple"
// import Multiple2 from "./Components/MainPage/mentalmath/Multiple2"
// import Multiple3 from "./Components/MainPage/mentalmath/multiple3"
// import Newactivityone from "./Components/MainPage/mentalmath/Newactivityone"
// import Newactivitytwo from "./Components/MainPage/mentalmath/Newactivitytwo"
// import Newactivitythree from "./Components/MainPage/mentalmath/Newactivitythree"


// import Halving from "./Components/MainPage/mentalmath/Halving"
// import Backtrack1 from "./Components/MainPage/mentalmath/Backtrack1";
// import Backtrack2 from "./Components/MainPage/mentalmath/Backtrack2";
// import Backtrack3 from "./Components/MainPage/mentalmath/Backtrack3";
// import Compositesmash from "./Components/MainPage/mentalmath/Compositesmash";
// import Prime from "./Components/MainPage/mentalmath/Prime";
// import Angles2 from "./Components/MainPage/mentalmath/Angles2";
// import Shapetrain from "./Components/MainPage/mentalmath/Shapetrain";
// import Shapes from "./Components/MainPage/mentalmath/Shapes";
// import Task2 from "./Components/MainPage/mentalmath/Task2";
// import Task3 from "./Components/MainPage/mentalmath/Task3";



// import Estimation2 from "./Components/MainPage/mentalmath/Estimation2";
// import Estimation1 from "./Components/MainPage/mentalmath/Estimation1";
// import Estimation3 from "./Components/MainPage/mentalmath/Estimation3";
// import Complement1 from "./Components/MainPage/mentalmath/Complement1";
// import Complement2 from "./Components/MainPage/mentalmath/Complement2";
// import Count from "./Components/MainPage/mentalmath/Count";
// import Dh from "./Components/MainPage/mentalmath/Dh";

// import Divisible3 from "./Components/MainPage/mentalmath/Divisible3";
// import Divisible from "./Components/MainPage/mentalmath/Divisible";
// import Indexl2 from "./Components/MainPage/mentalmath/Indexl2";
// import Indexl1 from "./Components/MainPage/mentalmath/Indexl1";
// import Lr1 from "./Components/MainPage/mentalmath/Lr1";
// import Lr2 from "./Components/MainPage/mentalmath/Lr2";
// import Lr3 from "./Components/MainPage/mentalmath/Lr3";
// import Rounding1 from "./Components/MainPage/mentalmath/Rounding1";
// import Rounding2 from "./Components/MainPage/mentalmath/Rounding2";

// import Factors from "./Components/MainPage/mentalmath/Factors";
// import Factors2 from "./Components/MainPage/mentalmath/Factors2";
// import Grouping1 from "./Components/MainPage/mentalmath/Grouping1";
// import Session141 from './Components/MainPage/mentalmath/lthree/Session141';
// import Session142 from './Components/MainPage/mentalmath/lthree/Session142';
// import Session15 from './Components/MainPage/mentalmath/lthree/Session15';
// import Session152 from './Components/MainPage/mentalmath/lthree/Session152';
// import Factors21 from './Components/MainPage/mentalmath/lthree/Factors21'

// import Session16 from './Components/MainPage/mentalmath/lthree/Session16'
// import Session162 from './Components/MainPage/mentalmath/lthree/Session162'
// import Session172 from './Components/MainPage/mentalmath/lthree/Session172'
// import Session171 from './Components/MainPage/mentalmath/lthree/Session171';
// import Halfof from "./Components/MainPage/mentalmath/level2/Halfsofhtml"
// import Session9 from "./Components/MainPage/mentalmath/level2/Session9"
// import Session9part2 from "./Components/MainPage/mentalmath/level2/Session9part2"
// import Session10 from "./Components/MainPage/mentalmath/level2/Sesssion10"
// import Session11 from "./Components/MainPage/mentalmath/level2/Session11"
// import Session11part2 from "./Components/MainPage/mentalmath/level2/Session11part2"
// import Session11part3 from "./Components/MainPage/mentalmath/level2/Session11part3"
// import Session11part4 from "./Components/MainPage/mentalmath/level2/Session11part4"
// import Session7 from "./Components/MainPage/mentalmath/level2/Sessions7"
// import Session8 from "./Components/MainPage/mentalmath/level2/Sessions8v2"
// import Integer2 from "./Components/MainPage/mentalmath/level2/Interger2"
// import Subtract1000 from "./Components/MainPage/mentalmath/level2/Subtract1000"
// import Subtract10000 from "./Components/MainPage/mentalmath/level2/Subtract10000"
// import Oneandhalf from "./Components/MainPage/mentalmath/level2/Oneandhalf"
// import Level1quiz from "./Components/MainPage/mentalmath/level2/Level1quiz"
// import Level2quiz from "./Components/MainPage/mentalmath/level2/Level2quiz"
// import Level3quiz from "./Components/MainPage/mentalmath/level2/Level3quiz"
// import Level4quiz from "./Components/MainPage/mentalmath/level2/Level4quiz"
// import Level5quiz from "./Components/MainPage/mentalmath/level2/Level5quiz"
// import Multiplynew from "./Components/MainPage/mentalmath/level2/Newactivitymultiply"
// import Twodigit from "./Components/MainPage/mentalmath/level2/Twodigit"
// import Twodigitb from "./Components/MainPage/mentalmath/level2/Twodigitb"



// import Sessions20v4 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
// import Sessions19v1 from "./Components/MainPage/mentalmath/level4/Sessions19v1"
// import Sessions19v2 from "./Components/MainPage/mentalmath/level4/Sessions19v2"
// import Sessions19v3 from "./Components/MainPage/mentalmath/level4/Sessions19v3"
// import Sessions20v1 from "./Components/MainPage/mentalmath/level4/Sessions20v1"
// import Sessions20v2 from "./Components/MainPage/mentalmath/level4/Sessions20v2"
// import Sessions20v3 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
// import Sessions20v5 from "./Components/MainPage/mentalmath/level4/Sessions20v5"
// import Sessions21v1 from "./Components/MainPage/mentalmath/level4/Sessions21v1"
// import Sessions21v2 from "./Components/MainPage/mentalmath/level4/Sessions21v2"
// import Magicsquare from "./Components/MainPage/mentalmath/level4/Magicsquare"
// import Proportion from "./Components/MainPage/mentalmath/level4/Proportion"
// import Scaling from "./Components/MainPage/mentalmath/level4/Scaling"
// import Ratio from "./Components/MainPage/mentalmath/level4/Ratio"
// import Gessop from "./Components/MainPage/mentalmath/level4/Gessop"
// import Nameriddle from './Components/MainPage/mentalmath/level4/Nameriddle'
// import TC1 from "./Components/MainPage/mentalmath/level4/Tc1"
// import TC2 from "./Components/MainPage/mentalmath/level4/Tc2"
// import TC3 from "./Components/MainPage/mentalmath/level4/Tc3"
// import Start from "./Components/MainPage/mentalmath/level4/start1"


// import Activity1 from "./Components/MainPage/mentalmath/lfive/Activity1";
// import Activity2 from "./Components/MainPage/mentalmath/lfive/Activity2";
// import Angle from "./Components/MainPage/mentalmath/lfive/Angle";
// import Measurement from "./Components/MainPage/mentalmath/lfive/Measurement";
// import Level1 from "./Components/MainPage/mentalmath/lfive/Level1";
// import Level2 from "./Components/MainPage/mentalmath/lfive/Level2";
// import Level3 from "./Components/MainPage/mentalmath/lfive/Level3";
// import Level4 from "./Components/MainPage/mentalmath/lfive/Level4";
// import Level5 from "./Components/MainPage/mentalmath/lfive/Level5";
// import Time from "./Components/MainPage/mentalmath/lfive/Time";
// import Divisoncarnival from "./Components/MainPage/mentalmath/lfive/Divisoncarnival";
// import Divisoncarnival2 from "./Components/MainPage/mentalmath/lfive/Divisoncarnival2";
// import Meterandcm from "./Components/MainPage/mentalmath/lfive/Meterandcm";
// import Percentnew from "./Components/MainPage/mentalmath/lfive/percentnew";
// import Weight from "./Components/MainPage/mentalmath/lfive/Weight";

// import Bargraph2 from "./Components/MainPage/mentalmath/level6/Bargraph2"
// import Bargraph from "./Components/MainPage/mentalmath/level6/Bargraph"
// import Datainterpretation from "./Components/MainPage/mentalmath/level6/Datainterpretation"
// import MatchPieChart from "./Components/MainPage/mentalmath/level6/Matchpiechart";
// import Mean from "./Components/MainPage/mentalmath/level6/Mean"
// import Median from "./Components/MainPage/mentalmath/level6/Median"
// import Mode from "./Components/MainPage/mentalmath/level6/Mode"
// import Piechart from "./Components/MainPage/mentalmath/level6/Piechart"
// import Puzzlepiechart from "./Components/MainPage/mentalmath/level6/Puzzlepiechart"
// import Survey from "./Components/MainPage/mentalmath/level6/Survey"
// import L7aone from "./Components/MainPage/mentalmath/level7/Activityone"
// import L7atwo from "./Components/MainPage/mentalmath/level7/Activitytwo"
// import L7athree from "./Components/MainPage/mentalmath/level7/Activitythree"
// import L7afour from "./Components/MainPage/mentalmath/level7/Activity4"
// import L7afive from "./Components/MainPage/mentalmath/level7/Activity5"
// import L7asix from "./Components/MainPage/mentalmath/level7/Activity6"




// import Activity11 from "./Components/MainPage/IntermediateAi/Activity1"
// import Activity12 from "./Components/MainPage/IntermediateAi/Activity2"
// import Activity13 from "./Components/MainPage/IntermediateAi/Activity3"
// import Activity14 from "./Components/MainPage/IntermediateAi/Activity4"
// import Activity15 from "./Components/MainPage/IntermediateAi/Activity5"
// import Activity16 from "./Components/MainPage/IntermediateAi/Activity6"
// import Activity17 from "./Components/MainPage/IntermediateAi/Activity7"
// import Activity18 from "./Components/MainPage/IntermediateAi/Activity8"
// import Activity19 from "./Components/MainPage/IntermediateAi/Activity9"
// import Activity20 from "./Components/MainPage/IntermediateAi/Activity10"
// import Activity21 from "./Components/MainPage/IntermediateAi/Activity11"
// import Activity22 from "./Components/MainPage/IntermediateAi/Activity12"
// import Activity23 from "./Components/MainPage/IntermediateAi/Activity13"
// import Activity24 from "./Components/MainPage/IntermediateAi/Activity14"

// import Digital1 from "./Components/MainPage/Digitalbasics/Digital1"
// import Digital2 from "./Components/MainPage/Digitalbasics/Digital2"
// import Digital3 from "./Components/MainPage/Digitalbasics/Digital3"
// import Digital4 from "./Components/MainPage/Digitalbasics/Digital4"
// import Digital5 from "./Components/MainPage/Digitalbasics/Digital5"
// import Digital6 from "./Components/MainPage/Digitalbasics/Digital6"
// import Digital7 from "./Components/MainPage/Digitalbasics/Digital7"
// import Digital9 from "./Components/MainPage/Digitalbasics/Digital9"
// import Digital10 from "./Components/MainPage/Digitalbasics/Digital10"
// import Digital11 from "./Components/MainPage/Digitalbasics/Digital11"
// import Digital12 from "./Components/MainPage/Digitalbasics/Digital12"

// import Count2s from "./Components/MainPage/mentalmath/Count2s"
// import Count10s from "./Components/MainPage/mentalmath/Count10s"
// import Count100s from "./Components/MainPage/mentalmath/Count100s"
// import Dashboard from "./Components/MainPage/Dashboard";

// import Break from "./Components/MainPage/Gcs/Break";
// import Flowchart from "./Components/MainPage/Gcs/Flowchart";
// import TraceTable from "./Components/MainPage/Gcs/TraceTable";
// import Binarytodecimal from "./Components/MainPage/Gcs/Binarytodecimal";
// import Decimaltobinary from "./Components/MainPage/Gcs/Decimaltobinary";
// import Hexadecimal from "./Components/MainPage/Gcs/Hexadecimal";
// import Unicode from "./Components/MainPage/Gcs/Unicode";
// import Pixelart from "./Components/MainPage/Gcs/Pixelart";
// import Ascii from "./Components/MainPage/Gcs/Ascii";
// import Sound from "./Components/MainPage/Gcs/Sound";



// export const AuthenticationState = createContext();

// function App() {
  
//   const [userAuthenticated, setuserAuthenticated] = useState(false)
//   const [verifiedAsMentor, setVerifiedAsMentor] = useState(false)
//   const [verifiedAsAdmin, setVerifiedAsAdmin] = useState(false)
//   const [verifiedAsBDE, setVerifiedAsBDE] = useState(false)
//   const location = useLocation();
//   const navigate = useNavigate()

//   useEffect(() => {
//     if (location.pathname !== "/signUp") {
//       const lastLoginTime = localStorage.getItem('lastLoginTime')
//       const authToken = localStorage.getItem('authToken')
//       console.log(location.pathname)
//       console.log("triggered")
//       if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && !userAuthenticated) {
//         CheckStatus(authToken)
//         console.log("app triggered")
//       }
//       else if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && userAuthenticated) { }
//       else if (authToken && (Date.now() - lastLoginTime) > 24 * 60 * 120 * 1000 && userAuthenticated) {
//         setuserAuthenticated(false)
//         navigate("/signIn")
//         console.log("user time out")
//       }
//       else {
//         setuserAuthenticated(false)
//         // No valid token at all — this is the case Authentication.jsx used
//         // to handle by navigating on its own, which raced this same effect.
//         // Now this effect is the single source of truth. Guarded to public
//         // routes so it fires once and doesn't re-trigger every render once
//         // already on /signIn (location.pathname is a dependency below, so
//         // this effect re-runs after the navigate — without the guard it
//         // would call navigate("/signIn") again every single time).
//         const publicPaths = ["/signIn", "/signUp", "/confirmemail"]
//         if (!publicPaths.includes(location.pathname)) {
//           navigate("/signIn")
//         }
//       }
//     }
//   }, [location.pathname,  userAuthenticated]
//   );


//   const CheckStatus = async (authToken) => {
//   const storedData = localStorage.getItem('UserKey');
  
//   if (!storedData || storedData === "undefined" || storedData === "null") {
//     setuserAuthenticated(false);
//     navigate("/signIn");
//     return;
//   }

//   try {
//     const params = JSON.parse(storedData);
//     fetchdata(params);
//     params["authToken"] = authToken;
    
//     const timeoutPromise = new Promise((_, reject) =>
//       setTimeout(() => reject(new Error('timeout')), 10000)
//     );
    
//     const responsedata = await Promise.race([
//       ConstructorEventPost(AuthenticateUser, params),
//       timeoutPromise
//     ]);
    
//     if (responsedata === "authentication_success") {
//       setuserAuthenticated(true);
//       // Only navigate if we're not already on home
//       if (location.pathname !== "/codomo/home") {
//         navigate("/codomo/home");
//       }
//     } else {
//       // Authentication failed - clear session and go to signIn
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('lastLoginTime');
//       localStorage.removeItem('UserKey');
//       setuserAuthenticated(false);
//       navigate("/signIn");
//     }
//   } catch (e) {
//     console.warn("CheckStatus failed:", e);
//     // On error, clear session to prevent infinite loop
//     localStorage.removeItem('authToken');
//     localStorage.removeItem('lastLoginTime');
//     localStorage.removeItem('UserKey');
//     setuserAuthenticated(false);
//     navigate("/signIn");
//   }
// };



//   const fetchdata = async (params) => {
//     const responsedata = await ConstructorEventGet(FetchHomePageDetails, params)
//     sessionStorage.setItem('UserData', JSON.stringify(responsedata[0]))
//     checkUserType(responsedata[0])
//   }

//   function checkUserType(data) {
//     const userType = data && data.user_type
//     if (userType === "mentor") {
//       setVerifiedAsMentor(true)
//     }
//     else if (userType === "admin") {
//       setVerifiedAsAdmin(true)
//     } else if (userType === "BDE") {
//       setVerifiedAsBDE(true)
//     }
//   }


//   return (
//     <div className="font-gilroy font-medium text-gray text-lg leading-[27px]">
//       <ToastContainer />
//       <AuthenticationState.Provider value={{ 
//   userAuthenticated, 
//   setuserAuthenticated: (value) => {
//     setuserAuthenticated(value);
//     if (value) {
//       navigate("/codomo/home");
//     }
//   }, 
//   verifiedAsMentor, 
//   setVerifiedAsMentor, 
//   verifiedAsAdmin, 
//   setVerifiedAsAdmin 
// }}>
    
//   <Routes>
//           <Route path="/home" element={<Navigate to="/signIn" />} />
//           <Route path="/codomo/home" element={userAuthenticated ? <HomePage /> : <Authentication />} />
//           <Route path="/codomo/landing" element={userAuthenticated ? <AboutOne /> : <Authentication />} />
//           <Route path="/codomo/course" element={userAuthenticated ? <Course /> : <Authentication />} />
//           <Route path="/codomo/contactus" element={userAuthenticated ? <ContactUs /> : <Authentication />} />
//           <Route path="/codomo/course/downloads" element={userAuthenticated ? <Downloads /> : <Authentication />} />
//           <Route path="/codomo/blog" element={userAuthenticated ? <Blog /> : <Authentication />} />
//           <Route path="/codomo/editprofile" element={userAuthenticated ? <EditProfile /> : <Authentication />} />
//           <Route path="/codomo/codeeditor" element={userAuthenticated ? <AdvancedCourse /> : <Authentication />} />
//           <Route path="/codomo/popup" element={userAuthenticated ? <Popup /> : <Authentication />} />
//           <Route path="/codomo/ActivityOne" element={userAuthenticated ? <ActivityOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityOneOne" element={userAuthenticated ? <ActivityOneOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityTwo" element={userAuthenticated ? <ActivityTwo /> : <Authentication />} />
//           <Route path="/codomo/ActivityTwoOne" element={userAuthenticated ? <ActivityTwoOne /> : <Authentication />} />
//           <Route path="/codomo/ActivityThree" element={userAuthenticated ? <ActivityThree /> : <Authentication />} />
//           <Route path="/codomo/StoryTellerActivity" element={userAuthenticated ? <StoryTellerActivity /> : <Authentication />} />
//           <Route path="/codomo/StoryTellerActivityOne" element={userAuthenticated ? <StoryTellerActivityOne /> : <Authentication />} />
//           <Route path="/codomo/ActivitySeven" element={userAuthenticated ? <ActivitySeven /> : <Authentication />} />
//           <Route path="/codomo/ActivityEight" element={userAuthenticated ? <ActivityEight /> : <Authentication />} />
//           <Route path="/codomo/ActivityNine" element={userAuthenticated ? <ActivityNine /> : <Authentication />} />
//           <Route path="/codomo/ActivityFour" element={userAuthenticated ? <ActivityFour /> : <Authentication />} />
//           <Route path="/codomo/ActivityFive" element={userAuthenticated ? <ActivityFive /> : <Authentication />} />
//           <Route path="/codomo/ActivitySix" element={userAuthenticated ? <ActivitySix /> : <Authentication />} />
//           <Route path="/codomo/ActivityTen" element={userAuthenticated ? <ActivityTen /> : <Authentication />} />
//           <Route path="/codomo/ActivityEleven" element={userAuthenticated ? <ActivityEleven /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionone" element={userAuthenticated ? <AppLabSessionone /> : <Authentication />} />
//           <Route path="/codomo/Webusb" element={userAuthenticated ? <Webusb /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionthree" element={userAuthenticated ? <AppLabSessionthree /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionfour" element={userAuthenticated ? <AppLabSessionfour /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionfive" element={userAuthenticated ? <AppLabSessionfive /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionsix" element={userAuthenticated ? <AppLabSessionsix /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionseven" element={userAuthenticated ? <AppLabSessionseven /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessioneight" element={userAuthenticated ? <AppLabSessioneight /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionnine" element={userAuthenticated ? <AppLabSessionnine /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessionten" element={userAuthenticated ? <AppLabSessionten /> : <Authentication />} />
//           <Route path="/codomo/AppLabSessioneleven" element={userAuthenticated ? <AppLabSessioneleven /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Index1" element={userAuthenticated ? <Index1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Index2" element={userAuthenticated ? <Index2 /> : <Authentication />} />
//           <Route path="/codomo/onecompiler" element={userAuthenticated ? <OneCompilerIframe /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack1" element={userAuthenticated ? <Backtrack1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack2" element={userAuthenticated ? <Backtrack2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Backtrack3" element={userAuthenticated ? <Backtrack3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation2" element={userAuthenticated ? <Estimation2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation1" element={userAuthenticated ? <Estimation1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Estimation3" element={userAuthenticated ? <Estimation3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Complement1" element={userAuthenticated ? <Complement1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Complement2" element={userAuthenticated ? <Complement2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Dh" element={userAuthenticated ? <Dh /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count" element={userAuthenticated ? <Count /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count2s" element={userAuthenticated ? <Count2s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count10s" element={userAuthenticated ? <Count10s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Count100s" element={userAuthenticated ? <Count100s /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divisible3" element={userAuthenticated ? <Divisible3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divisible" element={userAuthenticated ? <Divisible /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Factors" element={userAuthenticated ? <Factors /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Factors2" element={userAuthenticated ? <Factors2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Grouping1" element={userAuthenticated ? <Grouping1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Rounding" element={userAuthenticated ? <Rounding1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Rounding2" element={userAuthenticated ? <Rounding2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Angles2" element={userAuthenticated ? <Angles2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Shapetrain" element={userAuthenticated ? <Shapetrain /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Shapes" element={userAuthenticated ? <Shapes /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Task2" element={userAuthenticated ? <Task2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Task3" element={userAuthenticated ? <Task3 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/Newactivityone" element={userAuthenticated ? <Newactivityone /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Newactivitytwo" element={userAuthenticated ? <Newactivitytwo /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Newactivitythree" element={userAuthenticated ? <Newactivitythree /> : <Authentication />} />




//           <Route path="/codomo/mentalmath/Indexl1" element={userAuthenticated ? <Indexl1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Indexl2" element={userAuthenticated ? <Indexl2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr1" element={userAuthenticated ? <Lr1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr2" element={userAuthenticated ? <Lr2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Lr3" element={userAuthenticated ? <Lr3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Halving" element={userAuthenticated ? <Halving /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Placevalue" element={userAuthenticated ? <Placevalue /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Placevalue2" element={userAuthenticated ? <Placevalue2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/placevalue3" element={userAuthenticated ? <Placevalue3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/placevalue4" element={userAuthenticated ? <Placevalue4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Divible2" element={userAuthenticated ? <Divisible2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple1" element={userAuthenticated ? <Multiple1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple2" element={userAuthenticated ? <Multiple2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Multiple3" element={userAuthenticated ? <Multiple3 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/Compositesmash" element={userAuthenticated ? <Compositesmash /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Prime" element={userAuthenticated ? <Prime /> : <Authentication />} />



//           <Route path="/codomo/mentalmath/lthree/Session172" element={userAuthenticated ? <Session172 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session141" element={userAuthenticated ? <Session141 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session15" element={userAuthenticated ? <Session15 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session152" element={userAuthenticated ? <Session152 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session16" element={userAuthenticated ? <Session16 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session162" element={userAuthenticated ? <Session162 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session171" element={userAuthenticated ? <Session171 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Session142" element={userAuthenticated ? <Session142 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lthree/Factors21" element={userAuthenticated ? <Factors21 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Multiplynew" element={userAuthenticated ? < Multiplynew /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Twodigit" element={userAuthenticated ? <Twodigit /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Twodigitb" element={userAuthenticated ? <Twodigitb /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level2/Level5quiz" element={userAuthenticated ? <Level5quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level4quiz" element={userAuthenticated ? <Level4quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level3quiz" element={userAuthenticated ? <Level3quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level2quiz" element={userAuthenticated ? <Level2quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Level1quiz" element={userAuthenticated ? <Level1quiz /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Subtract1000" element={userAuthenticated ? <Subtract1000 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Subtract10000" element={userAuthenticated ? <Subtract10000 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Integer2" element={userAuthenticated ? <Integer2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Halfoften" element={userAuthenticated ? <Halfof /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session9" element={userAuthenticated ? <Session9 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session9part2" element={userAuthenticated ? <Session9part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11" element={userAuthenticated ? <Session11 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11part3" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Sessionpart3" element={userAuthenticated ? <Session11part3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Sessionpart4" element={userAuthenticated ? <Session11part4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session10" element={userAuthenticated ? <Session10 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session11part2" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session8" element={userAuthenticated ? <Session8 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level2/Session7" element={userAuthenticated ? <Session7 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level2/Oneandhalf" element={userAuthenticated ? <Oneandhalf /> : <Authentication />} />



//           <Route path="/codomo/mentalmath/level4/Magicsquare" element={userAuthenticated ? <Magicsquare /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Proportion" element={userAuthenticated ? <Proportion /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Ratio" element={userAuthenticated ? <Ratio /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Scaling" element={userAuthenticated ? <Scaling /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Gessop" element={userAuthenticated ? <Gessop /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Nameriddle" element={userAuthenticated ? <Nameriddle /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level4/Sessions20v4" element={userAuthenticated ? <Sessions20v4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Start" element={userAuthenticated ? <Start /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level4/Start/Tc1" element={userAuthenticated ? <TC1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Start/Tc2" element={userAuthenticated ? <TC2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Tc3" element={userAuthenticated ? <TC3 /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/level4/Sessions19v1" element={userAuthenticated ? <Sessions19v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions19v2" element={userAuthenticated ? <Sessions19v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions19v3" element={userAuthenticated ? <Sessions19v3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v1" element={userAuthenticated ? <Sessions20v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v2" element={userAuthenticated ? <Sessions20v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v3" element={userAuthenticated ? <Sessions20v3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions20v5" element={userAuthenticated ? <Sessions20v5 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions21v1" element={userAuthenticated ? <Sessions21v1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level4/Sessions21v2" element={userAuthenticated ? <Sessions21v2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Activity1" element={userAuthenticated ? <Activity1 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Angle" element={userAuthenticated ? <Angle /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Time" element={userAuthenticated ? <Time /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement" element={userAuthenticated ? <Measurement /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/lfive/Measurement/level1" element={userAuthenticated ? <Level1 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level2" element={userAuthenticated ? <Level2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level3" element={userAuthenticated ? <Level3 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level4" element={userAuthenticated ? <Level4 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Measurement/level5" element={userAuthenticated ? <Level5 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival" element={userAuthenticated ? <Divisoncarnival /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival2" element={userAuthenticated ? <Divisoncarnival2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Divisoncarnival2" element={userAuthenticated ? <Divisoncarnival2 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Meterandcm" element={userAuthenticated ? <Meterandcm /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Percentnew" element={userAuthenticated ? <Percentnew /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/lfive/Weight" element={userAuthenticated ? <Weight /> : <Authentication />} />


//           <Route path="/codomo/mentalmath/level7/Binaryone" element={userAuthenticated ? <L7aone /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Binarytwo" element={userAuthenticated ? <L7atwo /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Binarythree" element={userAuthenticated ? <L7athree /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Security" element={userAuthenticated ? <L7afour /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Activity5" element={userAuthenticated ? <L7afive /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/level7/Activity6" element={userAuthenticated ? <L7asix /> : <Authentication />} />

//           <Route path="/codomo/mentalmath/Bargraph2" element={userAuthenticated ? <Bargraph2 /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Bargraph" element={userAuthenticated ? <Bargraph /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Datainterpretation" element={userAuthenticated ? <Datainterpretation /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Matchpiechart" element={userAuthenticated ? <MatchPieChart /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Mean" element={userAuthenticated ? <Mean /> : <Authentication />} />                                   <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Median" element={userAuthenticated ? <Median /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Mode" element={userAuthenticated ? <Mode /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Piechart" element={userAuthenticated ? <Piechart /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Puzzlepiechart" element={userAuthenticated ? <Puzzlepiechart /> : <Authentication />} />
//           <Route path="/codomo/mentalmath/Survey" element={userAuthenticated ? <Survey /> : <Authentication />} />


//           <Route path="/codomo/IntermediateAi/Activity1" element={userAuthenticated ? <Activity11 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity12" element={userAuthenticated ? <Activity12 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity13" element={userAuthenticated ? <Activity13 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity14" element={userAuthenticated ? <Activity14 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity15" element={userAuthenticated ? <Activity15 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity16" element={userAuthenticated ? <Activity16 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity17" element={userAuthenticated ? <Activity17 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity18" element={userAuthenticated ? <Activity18 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity19" element={userAuthenticated ? <Activity19 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity20" element={userAuthenticated ? <Activity20 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity21" element={userAuthenticated ? <Activity21 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity22" element={userAuthenticated ? <Activity22 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity23" element={userAuthenticated ? <Activity23 /> : <Authentication />} />
//           <Route path="/codomo/IntermediateAi/Activity24" element={userAuthenticated ? <Activity24 /> : <Authentication />} />


//           <Route path="/codomo/Digitalbasics/Digital1" element={userAuthenticated ? <Digital1 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital2" element={userAuthenticated ? <Digital2 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital3" element={userAuthenticated ? <Digital3 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital4" element={userAuthenticated ? <Digital4 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital5" element={userAuthenticated ? <Digital5 /> : <Authentication />} />
//           {/* <Route path="/codomo/Digitalbasics/Digital5" element={userAuthenticated ? <Digital5 /> : <Authentication />} /> */}
//           <Route path="/codomo/Digitalbasics/Digital6" element={userAuthenticated ? <Digital6 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital7" element={userAuthenticated ? <Digital7 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital9" element={userAuthenticated ? <Digital9 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital10" element={userAuthenticated ? <Digital10 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital11" element={userAuthenticated ? <Digital11 /> : <Authentication />} />
//           <Route path="/codomo/Digitalbasics/Digital12" element={userAuthenticated ? <Digital12 /> : <Authentication />} />


//           <Route path="/codomo/mentor/activities" element={userAuthenticated ? verifiedAsMentor ? <MentorActivities /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           {/* <Route path="/codomo/mentor/addbatch" element={userAuthenticated ? verifiedAsAdmin ? <AddBatch /> : <Navigate to="/codomo/home"/> : <Authentication />} /> */}
//           <Route path="/codomo/mentor/notification" element={userAuthenticated ? verifiedAsMentor ? <NotificationService /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/admiration" element={userAuthenticated ? verifiedAsMentor ? <Admiration /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/dashboard" element={userAuthenticated ? verifiedAsMentor ? <Dashboard /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           {/* <Route path="/codomo/mentor/addstudent" element={userAuthenticated ?verifiedAsAdmin ?<AddStudent /> : <Navigate to="/codomo/home"/> : <Authentication />} /> */}
//           <Route path="/codomo/mentor/addblog" element={userAuthenticated ? verifiedAsMentor ? <AddBlog /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/mentor/editbatch" element={userAuthenticated ? <EditBatch /> : <Authentication />} />

//           <Route path="/codomo/Gcse/TraceTable" element={userAuthenticated ? <TraceTable /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Flowchart" element={userAuthenticated ? <Flowchart /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Break" element={userAuthenticated ? <Break /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Binarytodecimal" element={userAuthenticated ? <Binarytodecimal /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Hexadecimal" element={userAuthenticated ? <Hexadecimal /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Decimaltobinary" element={userAuthenticated ? <Decimaltobinary /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Unicode" element={userAuthenticated ? <Unicode /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Pixelart" element={userAuthenticated ? <Pixelart /> : <Authentication />} />
//           <Route path="/codomo/Gcse/Sound" element={userAuthenticated ? <Sound /> : <Authentication />} />

//           <Route path="/codomo/Gcse/Ascii" element={userAuthenticated ? <Ascii /> : <Authentication />} />



//           <Route path="/codomo/admin/createbatch" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           {/* <Route path="/codomo/admin/DemoDetails" element={userAuthenticated ? verifiedAsAdmin || verifiedAsBDE ? <DemoDetails /> : <Navigate to="/codomo/home" /> : <Authentication />} /> */}
//           {/* <Route path="/codomo/admin/DemoDetailsForm" element={userAuthenticated ? verifiedAsAdmin || verifiedAsBDE ? <DemoDetailsForm /> : <Navigate to="/codomo/home" /> : <Authentication />} /> */}

//           <Route path="/codomo/admin/addbatch" element={userAuthenticated ? verifiedAsAdmin ? <AddBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/addstudent" element={userAuthenticated ? verifiedAsAdmin ? <AddStudent /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/usermanagement" element={userAuthenticated ? verifiedAsAdmin ? <UserManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/createnewuser" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewUser /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/coursemanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/createnewcourse" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewCourse /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/activitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <ActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/downloadsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseDownloadsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/subactivitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <SubActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/mappingmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseMappingManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/assiginingcoursetomentor" element={userAuthenticated ? verifiedAsAdmin ? <AssiginingCourseToMentor /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/batchmanagement" element={userAuthenticated ? verifiedAsAdmin ? <BatchManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/codomo/admin/assignBatch" element={<AssignBatchToTheMentor />} />
//           <Route path="/codomo/admin/accountsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <AccountsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />



//           <Route path="/" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <Authentication />} />
//           <Route path="/confirmemail" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <EmailConfirm />} />
//           <Route path="/signIn" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignIn />} />
//           <Route path="/signUp" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignUp />} />
//           <Route path="/videoCallActivity" element={<VideoCallActivity />} />
//           <Route path="/voiceCallActivity" element={<VoiceCallActivity />} />
//           <Route path="/chatScreen" element={<ChatScreen />} />
//           <Route path="/googleMeet" element={<GoogleMeet />} />




//           <Route path="*" element={<ErrorPage />} />
//         </Routes>
//       </AuthenticationState.Provider>
//     </div>
//   );
// }

// export default App;




























import { Navigate, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState, createContext, useContext } from 'react';
import HomePage from "./Components/MainPage/HomePage";
import SignIn from "./Components/MainPage/SignIn";
import SignUp from "./Components/MainPage/SignUp"
import Course from "./Components/MainPage/Course";
import AboutOne from "./Components/MainPage/AboutOne"
import EmailConfirm from "./Components/MainPage/EmailConfirm";
import ContactUs from "./Components/MainPage/ContactUs"
import Downloads from "./Components/MainPage/Downloads"
import ErrorPage from "./Components/404ErrorPage";
import MentorActivities from "./Components/MainPage/MentorActivities";
import Authentication from "./Components/Authentication/Authentication";
import AddBatch from "./Components/MainPage/AddBatch";
import AddStudent from "./Components/MainPage/AddStudent"
import Blog from "./Components/MainPage/Blog"
import AddBlog from "./Components/MainPage/AddBlog";
import EditBatch from "./Components/MainPage/EditBatch";
import EditProfile from "./Components/MainPage/EditProfile";
import UserManagement from "./Components/MainPage/UserManagement";
import CreateNewUser from "./Components/MainPage/CreateNewUser";
import CourseManagement from "./Components/MainPage/CourseManagement";
import CreateNewCourse from "./Components/MainPage/CreateNewCourse";
import ActivityManagement from "./Components/MainPage/ActivityManagement";
import CourseDownloadsManagement from "./Components/MainPage/CourseDownloadsManagement";
import SubActivityManagement from "./Components/MainPage/SubActivityManagement";
import AdvancedCourse from "./Components/MainPage/AdvancedCourse";
import CourseMappingManagement from "./Components/MainPage/CourseMappingManagement";
import OneCompilerIframe from "./Components/MainPage/OneCompilerIframe";
import Admiration from "./Components/MainPage/Admiration";
import Popup from "./Components/MainPage/Popup";
import NotificationService from "./Components/MainPage/NotificationService";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthenticateUser, FetchHomePageDetails } from './api/aws-api';
import { ConstructorEventPost, ConstructorEventGet } from './Event/event';
import ActivityOne from "./Components/MainPage/ActivityOne";
import ActivityOneOne from "./Components/MainPage/ActivityOneOne";
import ActivityTwo from "./Components/MainPage/ActivityTwo";
import ActivityTwoOne from "./Components/MainPage/ActivityTwoOne";
import ActivityThree from "./Components/MainPage/ActivityThree";
import ActivityFour from "./Components/MainPage/ActivityFour";
import ActivityNine from "./Components/MainPage/ActivityNine";
import StoryTellerActivity from "./Components/MainPage/StoryTellerActivity";
import StoryTellerActivityOne from "./Components/MainPage/StoryTellerActivityOne";
import ActivitySeven from "./Components/MainPage/ActivitySeven"
import ActivityEight from "./Components/MainPage/ActivityEight"
import ActivityFive from "./Components/MainPage/ActivityFive"
import ActivitySix from "./Components/MainPage/ActivitySix"
import ActivityTen from "./Components/MainPage/ActivityTen"
import ActivityEleven from "./Components/MainPage/ActivityEleven"
import AppLabSessionone from "./Components/MainPage/AppLabSessionone"
import AppLabSessionthree from "./Components/MainPage/AppLabSessionthree"
import Webusb from "./Components/MainPage/Webusb"
import AppLabSessionfour from "./Components/MainPage/AppLabSessionfour"
import AppLabSessionfive from "./Components/MainPage/AppLabSessionfive"
import AppLabSessionsix from "./Components/MainPage/AppLabSessionsix"
import AppLabSessionseven from "./Components/MainPage/AppLabSessionseven"
import AppLabSessioneight from "./Components/MainPage/AppLabSessioneight"
import AppLabSessionnine from "./Components/MainPage/AppLabSessionnine"
import AppLabSessionten from "./Components/MainPage/AppLabSessionten"
import AssiginingCourseToMentor from "./Components/MainPage/AssiginingCourseToMentor"
import AppLabSessioneleven from "./Components/MainPage/AppLabSessioneleven"
import VideoCallActivity from "./Components/MainPage/VideoCallActivity";
import VoiceCallActivity from "./Components/MainPage/VoiceCallActivity";
import ChatScreen from "./Components/MainPage/ChatScreen";
import GoogleMeet from "./Components/MainPage/GoogleMeet";
import BatchManagement from "./Components/MainPage/BatchManagement";
import AssignBatchToTheMentor from "./Components/MainPage/AssignBatchToMentor";
import TransferBatchToMentor from "./Components/MainPage/TransferBatchToMentor"; // adjust path to match your folder structure

import AccountsManagement from "./Components/MainPage/AccountsManagement";
import CreateNewBatch from "./Components/MainPage/CreateNewBatch";

import Index1 from "./Components/MainPage/mentalmath/Index1";
import Index2 from "./Components/MainPage/mentalmath/Index2";
import Placevalue from "./Components/MainPage/mentalmath/Placevalue";
import Placevalue2 from "./Components/MainPage/mentalmath/Placevalue2";
import Placevalue3 from "./Components/MainPage/mentalmath/Placevalue3";
import Placevalue4 from "./Components/MainPage/mentalmath/Placevalue4";
import Divisible2 from "./Components/MainPage/mentalmath/Divisible2"
import Multiple1 from "./Components/MainPage/mentalmath/Multiple"
import Multiple2 from "./Components/MainPage/mentalmath/Multiple2"
import Multiple3 from "./Components/MainPage/mentalmath/multiple3"
import Newactivityone from "./Components/MainPage/mentalmath/Newactivityone"
import Newactivitytwo from "./Components/MainPage/mentalmath/Newactivitytwo"
import Newactivitythree from "./Components/MainPage/mentalmath/Newactivitythree"

import Halving from "./Components/MainPage/mentalmath/Halving"
import Backtrack1 from "./Components/MainPage/mentalmath/Backtrack1";
import Backtrack2 from "./Components/MainPage/mentalmath/Backtrack2";
import Backtrack3 from "./Components/MainPage/mentalmath/Backtrack3";
import Compositesmash from "./Components/MainPage/mentalmath/Compositesmash";
import Prime from "./Components/MainPage/mentalmath/Prime";
import Angles2 from "./Components/MainPage/mentalmath/Angles2";
import Shapetrain from "./Components/MainPage/mentalmath/Shapetrain";
import Shapes from "./Components/MainPage/mentalmath/Shapes";
import Task2 from "./Components/MainPage/mentalmath/Task2";
import Task3 from "./Components/MainPage/mentalmath/Task3";

import Estimation2 from "./Components/MainPage/mentalmath/Estimation2";
import Estimation1 from "./Components/MainPage/mentalmath/Estimation1";
import Estimation3 from "./Components/MainPage/mentalmath/Estimation3";
import Complement1 from "./Components/MainPage/mentalmath/Complement1";
import Complement2 from "./Components/MainPage/mentalmath/Complement2";
import Count from "./Components/MainPage/mentalmath/Count";
import Dh from "./Components/MainPage/mentalmath/Dh";

import Divisible3 from "./Components/MainPage/mentalmath/Divisible3";
import Divisible from "./Components/MainPage/mentalmath/Divisible";
import Indexl2 from "./Components/MainPage/mentalmath/Indexl2";
import Indexl1 from "./Components/MainPage/mentalmath/Indexl1";
import Lr1 from "./Components/MainPage/mentalmath/Lr1";
import Lr2 from "./Components/MainPage/mentalmath/Lr2";
import Lr3 from "./Components/MainPage/mentalmath/Lr3";
import Rounding1 from "./Components/MainPage/mentalmath/Rounding1";
import Rounding2 from "./Components/MainPage/mentalmath/Rounding2";

import Factors from "./Components/MainPage/mentalmath/Factors";
import Factors2 from "./Components/MainPage/mentalmath/Factors2";
import Grouping1 from "./Components/MainPage/mentalmath/Grouping1";
import Session141 from './Components/MainPage/mentalmath/lthree/Session141';
import Session142 from './Components/MainPage/mentalmath/lthree/Session142';
import Session15 from './Components/MainPage/mentalmath/lthree/Session15';
import Session152 from './Components/MainPage/mentalmath/lthree/Session152';
import Factors21 from './Components/MainPage/mentalmath/lthree/Factors21'

import Session16 from './Components/MainPage/mentalmath/lthree/Session16'
import Session162 from './Components/MainPage/mentalmath/lthree/Session162'
import Session172 from './Components/MainPage/mentalmath/lthree/Session172'
import Session171 from './Components/MainPage/mentalmath/lthree/Session171';
import Halfof from "./Components/MainPage/mentalmath/level2/Halfsofhtml"
import Session9 from "./Components/MainPage/mentalmath/level2/Session9"
import Session9part2 from "./Components/MainPage/mentalmath/level2/Session9part2"
import Session10 from "./Components/MainPage/mentalmath/level2/Sesssion10"
import Session11 from "./Components/MainPage/mentalmath/level2/Session11"
import Session11part2 from "./Components/MainPage/mentalmath/level2/Session11part2"
import Session11part3 from "./Components/MainPage/mentalmath/level2/Session11part3"
import Session11part4 from "./Components/MainPage/mentalmath/level2/Session11part4"
import Session7 from "./Components/MainPage/mentalmath/level2/Sessions7"
import Session8 from "./Components/MainPage/mentalmath/level2/Sessions8v2"
import Integer2 from "./Components/MainPage/mentalmath/level2/Interger2"
import Subtract1000 from "./Components/MainPage/mentalmath/level2/Subtract1000"
import Subtract10000 from "./Components/MainPage/mentalmath/level2/Subtract10000"
import Oneandhalf from "./Components/MainPage/mentalmath/level2/Oneandhalf"
import Level1quiz from "./Components/MainPage/mentalmath/level2/Level1quiz"
import Level2quiz from "./Components/MainPage/mentalmath/level2/Level2quiz"
import Level3quiz from "./Components/MainPage/mentalmath/level2/Level3quiz"
import Level4quiz from "./Components/MainPage/mentalmath/level2/Level4quiz"
import Level5quiz from "./Components/MainPage/mentalmath/level2/Level5quiz"
import Multiplynew from "./Components/MainPage/mentalmath/level2/Newactivitymultiply"
import Twodigit from "./Components/MainPage/mentalmath/level2/Twodigit"
import Twodigitb from "./Components/MainPage/mentalmath/level2/Twodigitb"

import Sessions20v4 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
import Sessions19v1 from "./Components/MainPage/mentalmath/level4/Sessions19v1"
import Sessions19v2 from "./Components/MainPage/mentalmath/level4/Sessions19v2"
import Sessions19v3 from "./Components/MainPage/mentalmath/level4/Sessions19v3"
import Sessions20v1 from "./Components/MainPage/mentalmath/level4/Sessions20v1"
import Sessions20v2 from "./Components/MainPage/mentalmath/level4/Sessions20v2"
import Sessions20v3 from "./Components/MainPage/mentalmath/level4/Sessions20v4"
import Sessions20v5 from "./Components/MainPage/mentalmath/level4/Sessions20v5"
import Sessions21v1 from "./Components/MainPage/mentalmath/level4/Sessions21v1"
import Sessions21v2 from "./Components/MainPage/mentalmath/level4/Sessions21v2"
import Magicsquare from "./Components/MainPage/mentalmath/level4/Magicsquare"
import Proportion from "./Components/MainPage/mentalmath/level4/Proportion"
import Scaling from "./Components/MainPage/mentalmath/level4/Scaling"
import Ratio from "./Components/MainPage/mentalmath/level4/Ratio"
import Gessop from "./Components/MainPage/mentalmath/level4/Gessop"
import Nameriddle from './Components/MainPage/mentalmath/level4/Nameriddle'
import TC1 from "./Components/MainPage/mentalmath/level4/Tc1"
import TC2 from "./Components/MainPage/mentalmath/level4/Tc2"
import TC3 from "./Components/MainPage/mentalmath/level4/Tc3"
import Start from "./Components/MainPage/mentalmath/level4/start1"

import Activity1 from "./Components/MainPage/mentalmath/lfive/Activity1";
import Activity2 from "./Components/MainPage/mentalmath/lfive/Activity2";
import Angle from "./Components/MainPage/mentalmath/lfive/Angle";
import Measurement from "./Components/MainPage/mentalmath/lfive/Measurement";
import Level1 from "./Components/MainPage/mentalmath/lfive/Level1";
import Level2 from "./Components/MainPage/mentalmath/lfive/Level2";
import Level3 from "./Components/MainPage/mentalmath/lfive/Level3";
import Level4 from "./Components/MainPage/mentalmath/lfive/Level4";
import Level5 from "./Components/MainPage/mentalmath/lfive/Level5";
import Time from "./Components/MainPage/mentalmath/lfive/Time";
import Divisoncarnival from "./Components/MainPage/mentalmath/lfive/Divisoncarnival";
import Divisoncarnival2 from "./Components/MainPage/mentalmath/lfive/Divisoncarnival2";
import Meterandcm from "./Components/MainPage/mentalmath/lfive/Meterandcm";
import Percentnew from "./Components/MainPage/mentalmath/lfive/percentnew";
import Weight from "./Components/MainPage/mentalmath/lfive/Weight";

import Bargraph2 from "./Components/MainPage/mentalmath/level6/Bargraph2"
import Bargraph from "./Components/MainPage/mentalmath/level6/Bargraph"
import Datainterpretation from "./Components/MainPage/mentalmath/level6/Datainterpretation"
import MatchPieChart from "./Components/MainPage/mentalmath/level6/Matchpiechart";
import Mean from "./Components/MainPage/mentalmath/level6/Mean"
import Median from "./Components/MainPage/mentalmath/level6/Median"
import Mode from "./Components/MainPage/mentalmath/level6/Mode"
import Piechart from "./Components/MainPage/mentalmath/level6/Piechart"
import Puzzlepiechart from "./Components/MainPage/mentalmath/level6/Puzzlepiechart"
import Survey from "./Components/MainPage/mentalmath/level6/Survey"
import L7aone from "./Components/MainPage/mentalmath/level7/Activityone"
import L7atwo from "./Components/MainPage/mentalmath/level7/Activitytwo"
import L7athree from "./Components/MainPage/mentalmath/level7/Activitythree"
import L7afour from "./Components/MainPage/mentalmath/level7/Activity4"
import L7afive from "./Components/MainPage/mentalmath/level7/Activity5"
import L7asix from "./Components/MainPage/mentalmath/level7/Activity6"

import Activity11 from "./Components/MainPage/IntermediateAi/Activity1"
import Activity12 from "./Components/MainPage/IntermediateAi/Activity2"
import Activity13 from "./Components/MainPage/IntermediateAi/Activity3"
import Activity14 from "./Components/MainPage/IntermediateAi/Activity4"
import Activity15 from "./Components/MainPage/IntermediateAi/Activity5"
import Activity16 from "./Components/MainPage/IntermediateAi/Activity6"
import Activity17 from "./Components/MainPage/IntermediateAi/Activity7"
import Activity18 from "./Components/MainPage/IntermediateAi/Activity8"
import Activity19 from "./Components/MainPage/IntermediateAi/Activity9"
import Activity20 from "./Components/MainPage/IntermediateAi/Activity10"
import Activity21 from "./Components/MainPage/IntermediateAi/Activity11"
import Activity22 from "./Components/MainPage/IntermediateAi/Activity12"
import Activity23 from "./Components/MainPage/IntermediateAi/Activity13"
import Activity24 from "./Components/MainPage/IntermediateAi/Activity14"

import Digital1 from "./Components/MainPage/Digitalbasics/Digital1"
import Digital2 from "./Components/MainPage/Digitalbasics/Digital2"
import Digital3 from "./Components/MainPage/Digitalbasics/Digital3"
import Digital4 from "./Components/MainPage/Digitalbasics/Digital4"
import Digital5 from "./Components/MainPage/Digitalbasics/Digital5"
import Digital6 from "./Components/MainPage/Digitalbasics/Digital6"
import Digital7 from "./Components/MainPage/Digitalbasics/Digital7"
import Digital9 from "./Components/MainPage/Digitalbasics/Digital9"
import Digital10 from "./Components/MainPage/Digitalbasics/Digital10"
import Digital11 from "./Components/MainPage/Digitalbasics/Digital11"
import Digital12 from "./Components/MainPage/Digitalbasics/Digital12"

import Count2s from "./Components/MainPage/mentalmath/Count2s"
import Count10s from "./Components/MainPage/mentalmath/Count10s"
import Count100s from "./Components/MainPage/mentalmath/Count100s"
import Dashboard from "./Components/MainPage/Dashboard";

import Break from "./Components/MainPage/Gcs/Break";
import Flowchart from "./Components/MainPage/Gcs/Flowchart";
import TraceTable from "./Components/MainPage/Gcs/TraceTable";
import Binarytodecimal from "./Components/MainPage/Gcs/Binarytodecimal";
import Decimaltobinary from "./Components/MainPage/Gcs/Decimaltobinary";
import Hexadecimal from "./Components/MainPage/Gcs/Hexadecimal";
import Unicode from "./Components/MainPage/Gcs/Unicode";
import Pixelart from "./Components/MainPage/Gcs/Pixelart";
import Ascii from "./Components/MainPage/Gcs/Ascii";
import Sound from "./Components/MainPage/Gcs/Sound";

export const AuthenticationState = createContext();

function App() {
  const [userAuthenticated, setuserAuthenticated] = useState(false)
  const [verifiedAsMentor, setVerifiedAsMentor] = useState(false)
  const [verifiedAsAdmin, setVerifiedAsAdmin] = useState(false)
  const [verifiedAsBDE, setVerifiedAsBDE] = useState(false)
  const location = useLocation();
  const navigate = useNavigate()

  // Re-checks session validity whenever the route changes (and once on
  // load). If a valid, non-expired authToken exists but React state hasn't
  // confirmed it yet, this triggers CheckStatus to verify it against the
  // backend and flip userAuthenticated accordingly.
  useEffect(() => {
    if (location.pathname !== "/signUp") {
      const lastLoginTime = localStorage.getItem('lastLoginTime')
      const authToken = localStorage.getItem('authToken')
      if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && !userAuthenticated) {
        CheckStatus(authToken)
      }
      else if (authToken && (Date.now() - lastLoginTime) < 24 * 60 * 120 * 1000 && userAuthenticated) { }
      else if (authToken && (Date.now() - lastLoginTime) > 24 * 60 * 120 * 1000 && userAuthenticated) {
        setuserAuthenticated(false)
        navigate("/signIn")
      }
      else {
        setuserAuthenticated(false)
      }
    }
  }, [location.pathname, userAuthenticated]
  );

  // Verifies a stored authToken against the backend, with a timeout so a
  // hung request can't leave the UI stuck. On success, flips
  // userAuthenticated (routes below react to that automatically). On
  // failure/timeout, clears the stale session and sends the user to sign in.
  const CheckStatus = async (authToken) => {
    const storedData = localStorage.getItem('UserKey');

    if (!storedData || storedData === "undefined" || storedData === "null") {
      setuserAuthenticated(false);
      navigate("/signIn");
      return;
    }

    try {
      const params = JSON.parse(storedData);
      fetchdata(params);
      params["authToken"] = authToken;

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('timeout')), 10000)
      );

      const responsedata = await Promise.race([
        ConstructorEventPost(AuthenticateUser, params),
        timeoutPromise
      ]);

      if (responsedata === "authentication_success") {
        setuserAuthenticated(true);
        if (location.pathname !== "/codomo/home") {
          navigate("/codomo/home");
        }
      } else {
        localStorage.removeItem('authToken');
        localStorage.removeItem('lastLoginTime');
        localStorage.removeItem('UserKey');
        setuserAuthenticated(false);
        navigate("/signIn");
      }
    } catch (e) {
      console.warn("CheckStatus failed:", e);
      localStorage.removeItem('authToken');
      localStorage.removeItem('lastLoginTime');
      localStorage.removeItem('UserKey');
      setuserAuthenticated(false);
      navigate("/signIn");
    }
  };

  const fetchdata = async (params) => {
    const responsedata = await ConstructorEventGet(FetchHomePageDetails, params)
    sessionStorage.setItem('UserData', JSON.stringify(responsedata[0]))
    checkUserType(responsedata[0])
  }

  function checkUserType(data) {
    const userType = data && data.user_type
    if (userType === "mentor") {
      setVerifiedAsMentor(true)
    }
    else if (userType === "admin") {
      setVerifiedAsAdmin(true)
    } else if (userType === "BDE") {
      setVerifiedAsBDE(true)
    }
  }

  return (
    <div className="font-gilroy font-medium text-gray text-lg leading-[27px]">
      <ToastContainer />
      <AuthenticationState.Provider value={{
        userAuthenticated,
        setuserAuthenticated: (value) => {
          setuserAuthenticated(value);
          if (value) {
            navigate("/codomo/home");
          }
        },
        verifiedAsMentor,
        setVerifiedAsMentor,
        verifiedAsAdmin,
        setVerifiedAsAdmin,
        verifiedAsBDE,
        setVerifiedAsBDE
      }}>
        <Routes>
          <Route path="/codomo/home" element={userAuthenticated ? <HomePage /> : <Authentication />} />
          <Route path="/codomo/landing" element={userAuthenticated ? <AboutOne /> : <Authentication />} />
          <Route path="/codomo/course" element={userAuthenticated ? <Course /> : <Authentication />} />
          <Route path="/codomo/contactus" element={userAuthenticated ? <ContactUs /> : <Authentication />} />
          <Route path="/codomo/course/downloads" element={userAuthenticated ? <Downloads /> : <Authentication />} />
          <Route path="/codomo/blog" element={userAuthenticated ? <Blog /> : <Authentication />} />
          <Route path="/codomo/editprofile" element={userAuthenticated ? <EditProfile /> : <Authentication />} />
          <Route path="/codomo/codeeditor" element={userAuthenticated ? <AdvancedCourse /> : <Authentication />} />
          <Route path="/codomo/popup" element={userAuthenticated ? <Popup /> : <Authentication />} />
          <Route path="/codomo/ActivityOne" element={userAuthenticated ? <ActivityOne /> : <Authentication />} />
          <Route path="/codomo/ActivityOneOne" element={userAuthenticated ? <ActivityOneOne /> : <Authentication />} />
          <Route path="/codomo/ActivityTwo" element={userAuthenticated ? <ActivityTwo /> : <Authentication />} />
          <Route path="/codomo/ActivityTwoOne" element={userAuthenticated ? <ActivityTwoOne /> : <Authentication />} />
          <Route path="/codomo/ActivityThree" element={userAuthenticated ? <ActivityThree /> : <Authentication />} />
          <Route path="/codomo/StoryTellerActivity" element={userAuthenticated ? <StoryTellerActivity /> : <Authentication />} />
          <Route path="/codomo/StoryTellerActivityOne" element={userAuthenticated ? <StoryTellerActivityOne /> : <Authentication />} />
          <Route path="/codomo/ActivitySeven" element={userAuthenticated ? <ActivitySeven /> : <Authentication />} />
          <Route path="/codomo/ActivityEight" element={userAuthenticated ? <ActivityEight /> : <Authentication />} />
          <Route path="/codomo/ActivityNine" element={userAuthenticated ? <ActivityNine /> : <Authentication />} />
          <Route path="/codomo/ActivityFour" element={userAuthenticated ? <ActivityFour /> : <Authentication />} />
          <Route path="/codomo/ActivityFive" element={userAuthenticated ? <ActivityFive /> : <Authentication />} />
          <Route path="/codomo/ActivitySix" element={userAuthenticated ? <ActivitySix /> : <Authentication />} />
          <Route path="/codomo/ActivityTen" element={userAuthenticated ? <ActivityTen /> : <Authentication />} />
          <Route path="/codomo/ActivityEleven" element={userAuthenticated ? <ActivityEleven /> : <Authentication />} />
          <Route path="/codomo/AppLabSessionone" element={userAuthenticated ? <AppLabSessionone /> : <Authentication />} />
          <Route path="/codomo/Webusb" element={userAuthenticated ? <Webusb /> : <Authentication />} />
          <Route path="/codomo/AppLabSessionthree" element={userAuthenticated ? <AppLabSessionthree /> : <Authentication />} />
          <Route path="/codomo/AppLabSessionfour" element={userAuthenticated ? <AppLabSessionfour /> : <Authentication />} />
          <Route path="/codomo/AppLabSessionfive" element={userAuthenticated ? <AppLabSessionfive /> : <Authentication />} />
          <Route path="/codomo/AppLabSessionsix" element={userAuthenticated ? <AppLabSessionsix /> : <Authentication />} />
          <Route path="/codomo/AppLabSessionseven" element={userAuthenticated ? <AppLabSessionseven /> : <Authentication />} />
          <Route path="/codomo/AppLabSessioneight" element={userAuthenticated ? <AppLabSessioneight /> : <Authentication />} />
          <Route path="/codomo/AppLabSessionnine" element={userAuthenticated ? <AppLabSessionnine /> : <Authentication />} />
          <Route path="/codomo/AppLabSessionten" element={userAuthenticated ? <AppLabSessionten /> : <Authentication />} />
          <Route path="/codomo/AppLabSessioneleven" element={userAuthenticated ? <AppLabSessioneleven /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Index1" element={userAuthenticated ? <Index1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Index2" element={userAuthenticated ? <Index2 /> : <Authentication />} />
          <Route path="/codomo/onecompiler" element={userAuthenticated ? <OneCompilerIframe /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Backtrack1" element={userAuthenticated ? <Backtrack1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Backtrack2" element={userAuthenticated ? <Backtrack2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Backtrack3" element={userAuthenticated ? <Backtrack3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Estimation2" element={userAuthenticated ? <Estimation2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Estimation1" element={userAuthenticated ? <Estimation1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Estimation3" element={userAuthenticated ? <Estimation3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Complement1" element={userAuthenticated ? <Complement1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Complement2" element={userAuthenticated ? <Complement2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Dh" element={userAuthenticated ? <Dh /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Count" element={userAuthenticated ? <Count /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Count2s" element={userAuthenticated ? <Count2s /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Count10s" element={userAuthenticated ? <Count10s /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Count100s" element={userAuthenticated ? <Count100s /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Divisible3" element={userAuthenticated ? <Divisible3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Divisible" element={userAuthenticated ? <Divisible /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Factors" element={userAuthenticated ? <Factors /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Factors2" element={userAuthenticated ? <Factors2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Grouping1" element={userAuthenticated ? <Grouping1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Rounding" element={userAuthenticated ? <Rounding1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Rounding2" element={userAuthenticated ? <Rounding2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Angles2" element={userAuthenticated ? <Angles2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Shapetrain" element={userAuthenticated ? <Shapetrain /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Shapes" element={userAuthenticated ? <Shapes /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Task2" element={userAuthenticated ? <Task2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Task3" element={userAuthenticated ? <Task3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Newactivityone" element={userAuthenticated ? <Newactivityone /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Newactivitytwo" element={userAuthenticated ? <Newactivitytwo /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Newactivitythree" element={userAuthenticated ? <Newactivitythree /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Indexl1" element={userAuthenticated ? <Indexl1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Indexl2" element={userAuthenticated ? <Indexl2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Lr1" element={userAuthenticated ? <Lr1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Lr2" element={userAuthenticated ? <Lr2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Lr3" element={userAuthenticated ? <Lr3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Halving" element={userAuthenticated ? <Halving /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Placevalue" element={userAuthenticated ? <Placevalue /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Placevalue2" element={userAuthenticated ? <Placevalue2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/placevalue3" element={userAuthenticated ? <Placevalue3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/placevalue4" element={userAuthenticated ? <Placevalue4 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Divible2" element={userAuthenticated ? <Divisible2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Multiple1" element={userAuthenticated ? <Multiple1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Multiple2" element={userAuthenticated ? <Multiple2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Multiple3" element={userAuthenticated ? <Multiple3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Compositesmash" element={userAuthenticated ? <Compositesmash /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Prime" element={userAuthenticated ? <Prime /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lthree/Session172" element={userAuthenticated ? <Session172 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lthree/Session141" element={userAuthenticated ? <Session141 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lthree/Session15" element={userAuthenticated ? <Session15 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lthree/Session152" element={userAuthenticated ? <Session152 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lthree/Session16" element={userAuthenticated ? <Session16 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lthree/Session162" element={userAuthenticated ? <Session162 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lthree/Session171" element={userAuthenticated ? <Session171 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lthree/Session142" element={userAuthenticated ? <Session142 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lthree/Factors21" element={userAuthenticated ? <Factors21 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Multiplynew" element={userAuthenticated ? <Multiplynew /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Twodigit" element={userAuthenticated ? <Twodigit /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Twodigitb" element={userAuthenticated ? <Twodigitb /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Level5quiz" element={userAuthenticated ? <Level5quiz /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Level4quiz" element={userAuthenticated ? <Level4quiz /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Level3quiz" element={userAuthenticated ? <Level3quiz /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Level2quiz" element={userAuthenticated ? <Level2quiz /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Level1quiz" element={userAuthenticated ? <Level1quiz /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Subtract1000" element={userAuthenticated ? <Subtract1000 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Subtract10000" element={userAuthenticated ? <Subtract10000 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Integer2" element={userAuthenticated ? <Integer2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Halfoften" element={userAuthenticated ? <Halfof /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Session9" element={userAuthenticated ? <Session9 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Session9part2" element={userAuthenticated ? <Session9part2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Session11" element={userAuthenticated ? <Session11 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Session11part3" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Sessionpart3" element={userAuthenticated ? <Session11part3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Sessionpart4" element={userAuthenticated ? <Session11part4 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Session10" element={userAuthenticated ? <Session10 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Session11part2" element={userAuthenticated ? <Session11part2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Session8" element={userAuthenticated ? <Session8 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Session7" element={userAuthenticated ? <Session7 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level2/Oneandhalf" element={userAuthenticated ? <Oneandhalf /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Magicsquare" element={userAuthenticated ? <Magicsquare /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Proportion" element={userAuthenticated ? <Proportion /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Ratio" element={userAuthenticated ? <Ratio /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Scaling" element={userAuthenticated ? <Scaling /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Gessop" element={userAuthenticated ? <Gessop /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Nameriddle" element={userAuthenticated ? <Nameriddle /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions20v4" element={userAuthenticated ? <Sessions20v4 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Start" element={userAuthenticated ? <Start /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Start/Tc1" element={userAuthenticated ? <TC1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Start/Tc2" element={userAuthenticated ? <TC2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Tc3" element={userAuthenticated ? <TC3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions19v1" element={userAuthenticated ? <Sessions19v1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions19v2" element={userAuthenticated ? <Sessions19v2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions19v3" element={userAuthenticated ? <Sessions19v3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions20v1" element={userAuthenticated ? <Sessions20v1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions20v2" element={userAuthenticated ? <Sessions20v2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions20v3" element={userAuthenticated ? <Sessions20v3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions20v5" element={userAuthenticated ? <Sessions20v5 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions21v1" element={userAuthenticated ? <Sessions21v1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level4/Sessions21v2" element={userAuthenticated ? <Sessions21v2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Activity1" element={userAuthenticated ? <Activity1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Angle" element={userAuthenticated ? <Angle /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Time" element={userAuthenticated ? <Time /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Measurement" element={userAuthenticated ? <Measurement /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Measurement/level1" element={userAuthenticated ? <Level1 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Measurement/level2" element={userAuthenticated ? <Level2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Measurement/level3" element={userAuthenticated ? <Level3 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Measurement/level4" element={userAuthenticated ? <Level4 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Measurement/level5" element={userAuthenticated ? <Level5 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Activity2" element={userAuthenticated ? <Activity2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Divisoncarnival" element={userAuthenticated ? <Divisoncarnival /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Divisoncarnival2" element={userAuthenticated ? <Divisoncarnival2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Meterandcm" element={userAuthenticated ? <Meterandcm /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Percentnew" element={userAuthenticated ? <Percentnew /> : <Authentication />} />
          <Route path="/codomo/mentalmath/lfive/Weight" element={userAuthenticated ? <Weight /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level7/Binaryone" element={userAuthenticated ? <L7aone /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level7/Binarytwo" element={userAuthenticated ? <L7atwo /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level7/Binarythree" element={userAuthenticated ? <L7athree /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level7/Security" element={userAuthenticated ? <L7afour /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level7/Activity5" element={userAuthenticated ? <L7afive /> : <Authentication />} />
          <Route path="/codomo/mentalmath/level7/Activity6" element={userAuthenticated ? <L7asix /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Bargraph2" element={userAuthenticated ? <Bargraph2 /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Bargraph" element={userAuthenticated ? <Bargraph /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Datainterpretation" element={userAuthenticated ? <Datainterpretation /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Matchpiechart" element={userAuthenticated ? <MatchPieChart /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Mean" element={userAuthenticated ? <Mean /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Median" element={userAuthenticated ? <Median /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Mode" element={userAuthenticated ? <Mode /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Piechart" element={userAuthenticated ? <Piechart /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Puzzlepiechart" element={userAuthenticated ? <Puzzlepiechart /> : <Authentication />} />
          <Route path="/codomo/mentalmath/Survey" element={userAuthenticated ? <Survey /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity1" element={userAuthenticated ? <Activity11 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity12" element={userAuthenticated ? <Activity12 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity13" element={userAuthenticated ? <Activity13 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity14" element={userAuthenticated ? <Activity14 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity15" element={userAuthenticated ? <Activity15 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity16" element={userAuthenticated ? <Activity16 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity17" element={userAuthenticated ? <Activity17 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity18" element={userAuthenticated ? <Activity18 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity19" element={userAuthenticated ? <Activity19 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity20" element={userAuthenticated ? <Activity20 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity21" element={userAuthenticated ? <Activity21 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity22" element={userAuthenticated ? <Activity22 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity23" element={userAuthenticated ? <Activity23 /> : <Authentication />} />
          <Route path="/codomo/IntermediateAi/Activity24" element={userAuthenticated ? <Activity24 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital1" element={userAuthenticated ? <Digital1 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital2" element={userAuthenticated ? <Digital2 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital3" element={userAuthenticated ? <Digital3 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital4" element={userAuthenticated ? <Digital4 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital5" element={userAuthenticated ? <Digital5 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital6" element={userAuthenticated ? <Digital6 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital7" element={userAuthenticated ? <Digital7 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital9" element={userAuthenticated ? <Digital9 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital10" element={userAuthenticated ? <Digital10 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital11" element={userAuthenticated ? <Digital11 /> : <Authentication />} />
          <Route path="/codomo/Digitalbasics/Digital12" element={userAuthenticated ? <Digital12 /> : <Authentication />} />
          <Route path="/codomo/mentor/activities" element={userAuthenticated ? verifiedAsMentor ? <MentorActivities /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/mentor/notification" element={userAuthenticated ? verifiedAsMentor ? <NotificationService /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/mentor/admiration" element={userAuthenticated ? verifiedAsMentor ? <Admiration /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/mentor/dashboard" element={userAuthenticated ? verifiedAsMentor ? <Dashboard /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/mentor/addblog" element={userAuthenticated ? verifiedAsMentor ? <AddBlog /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/mentor/editbatch" element={userAuthenticated ? <EditBatch /> : <Authentication />} />
          <Route path="/codomo/Gcse/TraceTable" element={userAuthenticated ? <TraceTable /> : <Authentication />} />
          <Route path="/codomo/Gcse/Flowchart" element={userAuthenticated ? <Flowchart /> : <Authentication />} />
          <Route path="/codomo/Gcse/Break" element={userAuthenticated ? <Break /> : <Authentication />} />
          <Route path="/codomo/Gcse/Binarytodecimal" element={userAuthenticated ? <Binarytodecimal /> : <Authentication />} />
          <Route path="/codomo/Gcse/Hexadecimal" element={userAuthenticated ? <Hexadecimal /> : <Authentication />} />
          <Route path="/codomo/Gcse/Decimaltobinary" element={userAuthenticated ? <Decimaltobinary /> : <Authentication />} />
          <Route path="/codomo/Gcse/Unicode" element={userAuthenticated ? <Unicode /> : <Authentication />} />
          <Route path="/codomo/Gcse/Pixelart" element={userAuthenticated ? <Pixelart /> : <Authentication />} />
          <Route path="/codomo/Gcse/Sound" element={userAuthenticated ? <Sound /> : <Authentication />} />
          <Route path="/codomo/Gcse/Ascii" element={userAuthenticated ? <Ascii /> : <Authentication />} />
          <Route path="/codomo/admin/createbatch" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/addbatch" element={userAuthenticated ? verifiedAsAdmin ? <AddBatch /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/addstudent" element={userAuthenticated ? verifiedAsAdmin ? <AddStudent /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/usermanagement" element={userAuthenticated ? verifiedAsAdmin ? <UserManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/createnewuser" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewUser /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/coursemanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/createnewcourse" element={userAuthenticated ? verifiedAsAdmin ? <CreateNewCourse /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/activitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <ActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/downloadsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseDownloadsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/subactivitymanagement" element={userAuthenticated ? verifiedAsAdmin ? <SubActivityManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/mappingmanagement" element={userAuthenticated ? verifiedAsAdmin ? <CourseMappingManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/assiginingcoursetomentor" element={userAuthenticated ? verifiedAsAdmin ? <AssiginingCourseToMentor /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/batchmanagement" element={userAuthenticated ? verifiedAsAdmin ? <BatchManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/codomo/admin/assignBatch" element={<AssignBatchToTheMentor />} />
          <Route path="/codomo/admin/transferBatch" element={<TransferBatchToMentor />} />
          <Route path="/codomo/admin/accountsmanagement" element={userAuthenticated ? verifiedAsAdmin ? <AccountsManagement /> : <Navigate to="/codomo/home" /> : <Authentication />} />
          <Route path="/" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignIn />} />
          <Route path="/confirmemail" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <EmailConfirm />} />
          <Route path="/signIn" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignIn />} />
          <Route path="/signUp" element={userAuthenticated ? <Navigate to="/codomo/home" /> : <SignUp />} />
          <Route path="/videoCallActivity" element={<VideoCallActivity />} />
          <Route path="/voiceCallActivity" element={<VoiceCallActivity />} />
          <Route path="/chatScreen" element={<ChatScreen />} />
          <Route path="/googleMeet" element={<GoogleMeet />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </AuthenticationState.Provider>
    </div>
  );
}

export default App;